import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Col,
  Dropdown,
  DropdownButton,
  Form,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import "react-datepicker/dist/react-datepicker.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import { ENDPOINT } from "../../../axios/apiConfig";
import { getData, postData, postFormData } from "../../../axios/apiHelper";
import { loader } from "../../../loader";
import CommonModel from "../../../Model/CommonModel";
import optimizeImage from "../../../Utils/optimizeImage";
import { createContent } from "../../CommonComponent/Validations";
import ResumableUploader from "../../../Utils/ResumableUploader";
import AddTopicsModal from "../../CommonComponent/AddTopicPopup";
import DatePicker from "react-datepicker";
import usaFlag from "../../assets/images/USAflag.png";

let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
let octaLachChildAccounts = ["wW0geGtDPvig5gF 6KbJrg==","UbCJcnLM9fe HsRMgX8c1A==","z2TunmZQf3QwCsICFTLGGQ==","qDgwPdToP05Kgzc g2VjIQ=="]
const LibraryCreateVWD = (props) => {
  const rdLikeArray = [
    "56Ek4feL/1A8mZgIKQWEqg==",
    "bWmUjqX7J011   WUTYn9g==",
    "MXl8m36VZFYXpgFVz3Pg0g==",
  ];
  const isLikeRdAccount = rdLikeArray.includes("FOkB/AUT2wGXRv ablqvbg==");
  const titleFieldRef = useRef(null);
  const [counterFlag, setCounterFlag] = useState(0);
  const [spcType, setSpcType] = useState(0);
  const [reseller, setReseller] = useState([]);
  const [show, setShow] = useState(false);
  const [commanShow, setCommanShow] = useState(false);
  const [hcpClickedFirst, setHcpClickedFirst] = useState([]);
  const [hcpIrtClickedFirst, setHcpIrtClickedFirst] = useState([]);
  const [getVideoArticle, setVideoArticle] = useState([]);
  const [id, setId] = useState("FOkB/AUT2wGXRv ablqvbg==");
  const handleClose = () => setShow(false);
  const navigate = useNavigate();
  const [error, setError] = useState({});
  const location = useLocation();
  const [ageGroups, setAgeGroups] = useState([]);
  const [categories, setCategories] = useState([]);
  // 🔹 States for topics
  const [clinicalTopic, setClinicalTopic] = useState([]);
  const [functionTopic, setFunctionTopic] = useState([]);
  // 🔹 States for selected topics
  const [selectedClinicalTopic, setSelectedClinicalTopic] = useState([]);
  const [selectedFunctionTopic, setSelectedFunctionTopic] = useState([]);

  const now = moment(new Date());
  const nextYear = now.add(1, "year");
  const [userInputs, setCreateLibraryInputs] = useState({
    expDatetime: nextYear.format(),
    // limit: "",
    uploadFile: "",
    uploadOfficeFile: "",
    contentTitle: "",
    keyAuthor: "",
    company: "",
    country: "",
    journalTitle: "",
    allowShare:
      "FOkB/AUT2wGXRv ablqvbg==" === "FOkB/AUT2wGXRv ablqvbg=="
        ? true
        : "",
    allowDownload:
      "FOkB/AUT2wGXRv ablqvbg==" === "FOkB/AUT2wGXRv ablqvbg=="
        ? true
        : "",
    allowPrint: "",
    product: "",
    docintelFormat: "",
    coverPhoto: "",
    specialRequirment: "",
    productionNotes: "",
    category: "",
    language: "",
    newLanguageCode: "",
    format: "",
    ibu: "",
    allowOneSource: "",
    allowRequest: "",
    allowDraft: false,
    allowVideo: false,
    comDatetime: "",
    cpdValue: "",
    sold_unsold_status: "sold",
    request_quote: false,
    pharmaArr: "",
    associatedAge: [],
    associatedTouchpoint: [],
    hideHCP: false,
    femaleOriented: false,
    creation_date: "",
    pushed_usa_flag: false,
    marketing_folder_name:""
  });
  const [language, setLanguage] = useState([
    { value: "English", label: "English" },
    { value: "Russian", label: "Russian" },
  ]);
  const [blindType, setBlindType] = useState([
    { value: "blinded", label: "blind" },
    { value: "unblinded", label: "unblind" },
  ]);
  const [mandatoryRole, setMandatoryRole] = useState([
    "Site User-Blinded",
    "Investigator-Blinded",
    "Site unblinded pharmacist",
  ]);
  const [ebookFile, setEbookFile] = useState([]);
  const [videoThumb, setVideoThumb] = useState([]);
  const [chapter, setChapter] = useState([
    {
      chapterTitle: "",
      uploadFile: "",
      fileValue: "",
      selectedVideo: "",
    },
  ]);
  const [pdfSpcData, setpdfSpcData] = useState([
    {
      chapterTitle: "",
      uploadFile: "",
      fileValue: "",
    },
  ]);
  const [userDetail, setUserDetail] = useState({
    user: {},
    production: [],
    pharmaArr: [],
    sales: [],
    country: [],
    format: [],
    product: [],
    hcp: [
      "Principal Investigator",
      "Sub-Investigator",
      "Study Coordinator",
      "Study Nurse",
      "Other",
    ],
  });

  const product = [
    {
      label: "Product name",
      type: "input",
      placeholder: "Type your product name",
    },
  ];

  const [ePrintType, setePrintType] = useState([]);
  const { title } = location.state || {};

  const [chapterSelect, setChapterSelect] = useState("");
  const [videoSelect, setVideoSelect] = useState("");
  const [uploadNewVideo, setUploadNewVideo] = useState(false);
  const [changeEmbeddedVideo, setChangeEmbeddedVideo] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [isNewTopicModal, setIsNewTopicModal] = useState(false);
  const [allTags, setAllTags] = useState({});
  const [newTag, setNewTag] = useState("");
  const [tagClickedFirst, setTagClickedFirst] = useState([]);
  const [tagsCounter, setTagsCounter] = useState(0);
  const [finalTags, setFinalTags] = useState([]);
  const [tagsReRender, setTagsReRender] = useState(0);
  const [updateflag, setupdateFlag] = useState(0);


  const scrollToFirstError = () => {
    setTimeout(() => {
      const firstErrorDiv = document.querySelector(
        ".login-validation, .login-validation-upload"
      );

      if (firstErrorDiv) {
        firstErrorDiv.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 100);
  };

    function LinkWithTooltip({ id, children, href, tooltip }) {
      return (
        <OverlayTrigger
          overlay={<Tooltip id={id}>{tooltip}</Tooltip>}
          placement="top"
          delayShow={300}
          delayHide={150}
        >
          <a href={href}>{children}</a>
        </OverlayTrigger>
      );
    }

  const octaId = [
    "UbCJcnLM9fe HsRMgX8c1A==",
    "wW0geGtDPvig5gF 6KbJrg==",
    "z2TunmZQf3QwCsICFTLGGQ==",
    "qDgwPdToP05Kgzc g2VjIQ==",
    "B7SHpAc XDXSH NXkN0rdQ==",
  ];

  const initalFun = async () => {
    loader("show");
    try {
      let reqpaload = {
        user_id: id,
        irt: location?.state?.flag == "mandatory" ? 1 : 0,
      };
      if (isLikeRdAccount) {
        reqpaload.isRdLib = 1;
      }
      const hadData = await postData(ENDPOINT.LIBRARYDETAIL, reqpaload);
      let country = [];
      if (hadData?.data?.data?.country?.length) {
        if (typeof hadData?.data?.data?.country == "string") {
          JSON.parse(hadData?.data?.data?.country)?.reduce(
            (objEntries, key) => {
              country.push({
                label: key,
                value: key,
              });
            }
          );
        } else {
          hadData?.data?.data?.country?.reduce((objEntries, key) => {
            country.push({
              label: key,
              value: key,
            });
          });
        }
      }
      setSpcType(hadData?.data?.data?.spcInc);

      let category = [];
      if (hadData?.data?.data?.category?.length) {
        hadData.data.data.category.forEach((key) => {
          category.push({
            label: key,
            value: key,
          });
        });
      }
      let tags = [];
      if (hadData?.data?.data?.tags?.length) {
        hadData?.data?.data?.tags?.forEach((item) => {
          tags.push(item?.value);
        });
      }

      let funtional_tags = [];

      if (
        ["UbCJcnLM9fe HsRMgX8c1A==",
          "wW0geGtDPvig5gF 6KbJrg==",
          "z2TunmZQf3QwCsICFTLGGQ==",
          "qDgwPdToP05Kgzc g2VjIQ==",
          "FOkB/AUT2wGXRv ablqvbg==",
          "iSnEsKu5gB/DRlycxB6G4g=="
        ].includes("FOkB/AUT2wGXRv ablqvbg==")
      ) {
        hadData?.data?.data?.functional_tags?.forEach((item) => {
          funtional_tags.push(item?.value);
        });
      }

      setePrintType(hadData?.data?.data?.fileType);
      setClinicalTopic(tags);
      setFunctionTopic(funtional_tags);
      setAllTags(tags);
      setUserDetail({
        ...userDetail,
        user: hadData?.data?.data?.user,
        production: hadData?.data?.data?.production,
        pharmaArr: hadData?.data?.data?.pharma_arr,
        country: country,
        costCenter: hadData?.data?.data?.costCenter,
        sales: hadData?.data?.data?.sale,
        format: hadData?.data?.data?.format,
        category: category,
        ibu: hadData?.data?.data?.ibu,
        product: hadData?.data?.data?.product,
        reseller: hadData?.data?.data?.reseller,
        trial: [{ label: "LEXx210", value: "3972" }],
        marketing_folder_name: hadData?.data?.data?.marketing_folder_name,
      });

      loader("hide");
    } catch (err) {
      loader("hide");
    }
  };

  useEffect(() => {
    if (
      userInputs?.category &&
      "FOkB/AUT2wGXRv ablqvbg==" === "FOkB/AUT2wGXRv ablqvbg==" &&
      userInputs.docintelFormat == "ebookVideo"
    ) {
      setChapter((prev) =>
        prev.map((item) => ({
          ...item,
          chapterCategory: userInputs?.category,
        }))
      );
    }
  }, [userInputs?.category]);

  useEffect(() => {
    initalFun();
    if (
      "FOkB/AUT2wGXRv ablqvbg==" === "FOkB/AUT2wGXRv ablqvbg==" ||
      "FOkB/AUT2wGXRv ablqvbg==" === "iSnEsKu5gB/DRlycxB6G4g=="
    ) {
      fetchAgeCategoriesData();
    }
  }, []);
  const handleChange = async (e, isSelectedName) => {
    if (e?.target?.files?.length < 1) {
      return;
    }
    if (
      "FOkB/AUT2wGXRv ablqvbg==" === "FOkB/AUT2wGXRv ablqvbg==" &&
      e?.target?.files?.length >= 1 &&
      isSelectedName == "uploadOfficeFile"
    ) {
      const file = e?.target?.files[0];
      const maxSize = 10 * 1024 * 1024;
      if (file.size > maxSize) {
        toast.warning("File size should not exceed 10 MB");
        e.target.value = null;
        return;
      }
    }

    if (isSelectedName == "docintelFormat") {
      if (e == "ebook") {
        setEbookFile([]);
        setpdfSpcData([
          {
            chapterTitle: "",
            uploadFile: "",
            fileValue: "",
          },
        ]);
      } else if (e == "ebookVideo") {
        setEbookFile([]);
        setChapter([
          {
            type: "pdf",
            chapterTitle: "",
            uploadFile: "",
            fileValue: "",
            selectedVideo: "",
            ...("FOkB/AUT2wGXRv ablqvbg==" ===
              "FOkB/AUT2wGXRv ablqvbg==" && {
              chapterCategory: userInputs?.category,
            }),
          },
        ]);
      } else if (e == "pdfSpc") {
        setEbookFile([]);
        setChapter([
          {
            chapterTitle: "",
            uploadFile: "",
            fileValue: "",
            selectedVideo: "",
          },
        ]);
      }
      setCreateLibraryInputs({
        ...userInputs,
        uploadFile: "",
        uploadOfficeFile: "",
        [isSelectedName ? isSelectedName : e?.target?.name]: isSelectedName
          ? e?.target?.files
            ? e?.target?.files
            : e
          : e?.target?.value,
        allowVideo: false,
      });
    } else {
      if (isSelectedName == "coverPhoto") {
        const file = e.target.files[0];
        let optimizedFile = await optimizeImage(file, { width: 125 });
        setCreateLibraryInputs({
          ...userInputs,
          ["coverPhoto"]: [optimizedFile],
        });
      } else if (isSelectedName == "videoUrl") {
        const file = e;
        setCreateLibraryInputs({
          ...userInputs,
          videoUrl: file,
          videoFileName: file.split("/").pop() || "",
        });
      } else {

        if("FOkB/AUT2wGXRv ablqvbg==" === "iSnEsKu5gB/DRlycxB6G4g=="){
              if (isSelectedName === "pushed_vwdJourney") {
                const isChecked = e; // true or false

                setCreateLibraryInputs((prev) => ({
                  ...prev,
                  pushed_vwdJourney: isChecked,
                  // If Push to VWD is ON, force sync_onesource to true
                  // If it's OFF, leave sync_onesource as is (user can control it manually)
                  // sync_onesource: isChecked ? true : prev.sync_onesource,
                }));

                return;
              }

              if (isSelectedName === "sync_onesource") {
                // Prevent turning off sync_onesource when pushed_vwdJourney is ON
                const isChecked = e;
                setCreateLibraryInputs((prev) => {
                  // if (prev.pushed_vwdJourney && e === false) {
                  //   // Ignore this change — keep it true
                  //   return prev;
                  // }

                  return {
                    ...prev,
                    sync_onesource: e,
                    pushed_usa_flag:isChecked ? prev.pushed_usa_flag : false,
                  };
                });

                return;
              }
        }

        setCreateLibraryInputs(
          {
          ...userInputs,
          [isSelectedName ? isSelectedName : e?.target?.name]: isSelectedName
            ? e?.target?.files
              ? e?.target?.files
              : e
            : e?.target?.value,
        });
      }
    }
  };

  const nextButtonClicked = async (e) => {
    if (
      userInputs.docintelFormat == "ebook" ||
      userInputs.docintelFormat == "ebookVideo"
    ) {
      userInputs.chapter = chapter;
    } else if (userInputs?.docintelFormat == "pdfSpc") {
      userInputs.pdfChapter = pdfSpcData;
    }
    if (
      userDetail?.user?.[0]?.flag == 1 &&
      userDetail?.user?.[0]?.group_id == 3
    ) {
      if (!userInputs?.trial) {
        userInputs.trial = "";
      }
      if (!userInputs?.blindType) {
        userInputs.blindType = "";
      }
    }

    const tagsToSend =
      "FOkB/AUT2wGXRv ablqvbg==" === "FOkB/AUT2wGXRv ablqvbg=="
        ? [...selectedClinicalTopic, ...selectedFunctionTopic]
        : tagClickedFirst;

    const err = createContent(
      userInputs,
      ebookFile,
      userDetail?.user?.[0]?.group_id,
      userDetail?.user?.[0]?.retailer,
      tagsToSend,
      true
    );

    if (Object.keys(err)?.length) {
      // if (Object.keys(err)[0] == "limit") {
      //   limitFieldRef.current.focus();
      // }

      if ("FOkB/AUT2wGXRv ablqvbg==" === "FOkB/AUT2wGXRv ablqvbg=="|| "FOkB/AUT2wGXRv ablqvbg==" === "iSnEsKu5gB/DRlycxB6G4g==") {
        setError(err); // set the error first so the divs are rendered

        setTimeout(() => {
          // Select the first visible error div
          const firstErrorDiv = document.querySelector(".login-validation");
          if (firstErrorDiv) {
            // Scroll smoothly to the error
            firstErrorDiv.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
          }
        }, 100); // slight delay to ensure divs are rendered
      } else {
        if (Object.keys(err)[0] == "contentTitle") {
          titleFieldRef.current.focus();
        }
        toast.error(err[Object.keys(err)[0]]);
        setError(err);
      }

      if ("FOkB/AUT2wGXRv ablqvbg==" !== "FOkB/AUT2wGXRv ablqvbg==") {
        toast.error(err[Object.keys(err)[0]]);
      }

      scrollToFirstError();
      return;
    } else {
      loader("show");
      try {
        let formData = new FormData();

        formData.append("productionNotes", userInputs?.productionNotes);
        formData.append(
          "production",
          userInputs?.production ? userInputs?.production : 0
        );

        formData.append("sales", userInputs?.sales ? userInputs?.sales : 0);
        formData.append(
          "costCenter",
          userInputs?.costCenter ? userInputs?.costCenter : ""
        );

        formData.append("limit", userInputs?.limit);
        formData.append("file", userInputs?.uploadFile?.[0]);
        formData.append("officeFile", userInputs?.uploadOfficeFile?.[0]);
        formData.append("title", userInputs?.contentTitle);
        if (userInputs?.videoUrl) {
          formData.append("videoUrl", userInputs.videoUrl);
          const fileName = userInputs.videoUrl.split("/").pop() || "";
          formData.append("videoFileName", fileName);
        }

        if ("FOkB/AUT2wGXRv ablqvbg==" == "B7SHpAc XDXSH NXkN0rdQ==") {
          formData.append("language", userInputs?.language);
          formData.append("new_language_code", userInputs?.newLanguageCode);
        }

        if (
          userDetail?.user?.[0]?.group_id == 3 &&
          userDetail?.user?.[0]?.flag == 1
        ) {
          let mandatoryValue;

          if (location?.state?.flag === "Non-mandatory") {
            mandatoryValue = false;
          } else if (location?.state?.flag === "mandatory") {
            mandatoryValue = true;
          } else {
            mandatoryValue = userInputs?.mandatory
              ? JSON.stringify(userInputs?.mandatory)
              : JSON.stringify(false);
          }

          formData.append("blindType", userInputs?.blindType);
          formData.append("trial", userInputs?.trial);

          formData.append("mandatory", JSON.stringify(mandatoryValue));

          let Role = [];
          if (location?.state?.flag === "mandatory") {
            if (location?.state?.title === "Site User-Blinded") {
              Role = ["Site User-Blinded"];
            } else if (location?.state?.title === "Investigator-Blinded") {
              Role = ["Investigator-Blinded"];
            } else if (location?.state?.title === "Site Unblinded Pharmacist") {
              Role = ["Site unblinded pharmacist"];
            } else {
              Role = hcpIrtClickedFirst?.length ? hcpIrtClickedFirst : [];
            }
          } else {
            Role = hcpClickedFirst?.length ? hcpClickedFirst : [];
          }
          formData.append("trail_user_type", JSON.stringify(Role));
        }

        if (
          userDetail?.user?.[0]?.group_id == 3 &&
          userDetail?.user?.[0]?.octaLach == 1
        ) {
          formData.append(
            "medical",
            userInputs?.medical
              ? JSON.stringify(userInputs?.medical)
              : JSON.stringify(false)
          );

          formData.append(
            "sync_onesource",
            userInputs?.sync_onesource
              ? JSON.stringify(userInputs?.sync_onesource)
              : JSON.stringify(false)
          );
        }

        if ("FOkB/AUT2wGXRv ablqvbg==" == "iRbx2CVT2fddhkNa9mlcBQ==") {
          formData.append(
            "sync_onesource",
            userInputs?.sync_onesource
              ? JSON.stringify(userInputs?.sync_onesource)
              : JSON.stringify(false)
          );
        }

        if (octaId.includes("FOkB/AUT2wGXRv ablqvbg==")) {
          formData.append(
            "sync_onesource",
            userInputs?.sync_onesource
              ? JSON.stringify(userInputs?.sync_onesource)
              : JSON.stringify(false)
          );
        }

        if ("FOkB/AUT2wGXRv ablqvbg==" == "8ifsyLFPesoMf3AL6fS3sA==") {
          formData.append(
            "pushed_article",
            userInputs?.pushed_article
              ? JSON.stringify(userInputs?.pushed_article)
              : JSON.stringify(false)
          );
        }
        const isoexDate = userInputs?.expDatetime
          ? moment(userInputs.expDatetime).toISOString()
          : "";

        if (userDetail?.user?.[0]?.group_id == 3) {
          // Set expDatetime to 2030 keeping month, day, time same
          formData.append(
            "expDatetime",
            moment().add(5, "years").toISOString()
          );
        } else {
          formData.append("expDatetime", isoexDate);
        }
        formData.append("company", userInputs?.company);
        formData.append("country", userInputs?.country);
        formData.append("pdfSubTitle", userInputs?.journalTitle);
        formData.append("keyAuthor", userInputs?.keyAuthor);
        formData.append("multiplePublisher", JSON.stringify(reseller));
        formData.append("allowShare", userInputs?.allowShare);
        formData.append("allowDownload", userInputs?.allowDownload);
        if ("FOkB/AUT2wGXRv ablqvbg==" === "iSnEsKu5gB/DRlycxB6G4g==") {
          if (userInputs?.pushed_vwdJourney) {
            formData.append(
              "associatedAge",
              JSON.stringify(userInputs?.associatedAge.filter(item=>item!== "All") || [])
            );
            formData.append(
              "associatedTouchpoint",
              JSON.stringify(userInputs?.associatedTouchpoint.filter(item=>item!== "All") || [])
            );
            formData.append(
              "femaleOriented",
              userInputs?.femaleOriented
                ? JSON.stringify(userInputs?.femaleOriented)
                : JSON.stringify(false)
            );
            formData.append(
              "pushed_vwdJourney",
              JSON.stringify(
                userInputs?.pushed_vwdJourney || JSON.stringify(false)
              )
            );
          } else {
            formData.append("associatedAge", JSON.stringify([]));
            formData.append("associatedTouchpoint", JSON.stringify([]));
            formData.append("femaleOriented", JSON.stringify(false));
            formData.append("pushed_vwdJourney", JSON.stringify(false));
          }
        } else {
          formData.append(
            "associatedAge",
            JSON.stringify(userInputs?.associatedAge.filter(item=>item!== "All") || [])
          );
          formData.append(
            "associatedTouchpoint",
            JSON.stringify(userInputs?.associatedTouchpoint.filter(item => item!== "All") || [])
          );

          formData.append(
            "femaleOriented",
            userInputs?.femaleOriented
              ? JSON.stringify(userInputs?.femaleOriented)
              : JSON.stringify(false)
          );

          formData.append(
            "pushed_vwdJourney",
            JSON.stringify(
              userInputs?.pushed_vwdJourney || JSON.stringify(false)
            )
          );
        }
        formData.append(
          "hideHCP",
          userInputs?.hideHCP
            ? JSON.stringify(userInputs?.hideHCP)
            : JSON.stringify(false)
        );
        // const isocrDate = userInputs?.creation_date
        //   ? moment(userInputs.creation_date).toISOString()
        //   : "";

        const isocrDate = userInputs?.creation_date
          ? moment(userInputs.creation_date).format("YYYY-MM-DD")
          : "";

        formData.append("creation_date", isocrDate);
        formData.append("marketing_folder_name", userInputs?.marketing_folder_name?.value ? userInputs?.marketing_folder_name?.value:"");
        formData.append("allowPrint", userInputs?.allowPrint);
        formData.append(
          "product",
          userInputs?.product?.value ? userInputs?.product?.value : ""
        );
        ebookFile?.forEach((item) => {
          formData.append("ebookData", item);
        });

        videoThumb?.forEach((item) => {
          formData.append("videoThumb", item);
        });

        formData.append(
          "fileType",
          userInputs?.docintelFormat == "pdfSpc"
            ? "ebook"
            : userInputs?.docintelFormat
        );
        if (userInputs?.docintelFormat == "pdfSpc") {
          formData.append("spcInc", spcType);
        }
        formData.append("coverPhoto", userInputs?.coverPhoto?.[0]);
        formData.append(
          "chapter",
          userInputs?.docintelFormat == "pdfSpc"
            ? JSON.stringify(pdfSpcData)
            : JSON.stringify(chapter)
        );
        formData.append("specialRequirment", userInputs?.specialRequirment);
        formData.append("createdBy", id);

        formData.append("category", userInputs?.category);
        formData.append("formatType", userInputs?.format);
        formData.append("ibu", userInputs?.ibu ? userInputs?.ibu : "");
        formData.append("allowOneSource", userInputs?.allowOneSource);
        formData.append(
          "allowLibrary",
          userInputs?.allowLibrary ? userInputs?.allowLibrary : 1
        );
        formData.append("allowRequest", userInputs?.allowRequest ? 1 : 0);
        formData.append(
          "allowDraft",
          userInputs?.draft
            ? JSON.stringify(userInputs?.draft)
            : JSON.stringify(false)
        );
        let allowVideoValue = 0;
        if (userInputs?.docintelFormat == "video") {
          formData.append("allowVideo", 0);
        } else {
          allowVideoValue = userInputs?.allowVideo ? 1 : 0;
          formData.append("allowVideo", userInputs?.allowVideo ? 1 : 0);
        }

        formData.append("comDatetime", userInputs?.comDatetime);
        formData.append("cpdValue", userInputs?.cpdValue);
        formData.append(
          "tags",
          "FOkB/AUT2wGXRv ablqvbg==" === "FOkB/AUT2wGXRv ablqvbg==" ||
            "FOkB/AUT2wGXRv ablqvbg==" === "iSnEsKu5gB/DRlycxB6G4g=="
            ? selectedClinicalTopic?.length
              ? JSON.stringify(selectedClinicalTopic)
              : ""
            : tagClickedFirst?.length
            ? JSON.stringify(tagClickedFirst)
            : ""
        );

        formData.append(
          "functional_tags",
          "FOkB/AUT2wGXRv ablqvbg==" === "FOkB/AUT2wGXRv ablqvbg==" ||
            "FOkB/AUT2wGXRv ablqvbg==" === "iSnEsKu5gB/DRlycxB6G4g=="
            ? selectedFunctionTopic?.length
              ? JSON.stringify(selectedFunctionTopic)
              : ""
            : ""
        );

        if (userDetail?.user?.[0]?.retailer == 1) {
          formData.append("request_quote", userInputs?.request_quote ? 1 : 0);
          formData.append("sold_unsold_status", userInputs?.sold_unsold_status);
          formData.append(
            "pharama_val",
            userInputs?.pharmaArr ? userInputs?.pharmaArr : ""
          );
        }

          formData.append(
            "pushed_usa_flag",userInputs?.pushed_usa_flag || false
          );

          formData.append(
            "from_vwd",true
          );
          if(props?.type === "vwd") formData.append("isVwd",true)

        const res = await postFormData(ENDPOINT.LIBRARYCREATE, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            CustomHeader: allowVideoValue,
          },
        });
        // console.log(userInputs,'userInputs')
        loader("hide");

        if (isLikeRdAccount) {
          if (
            userInputs?.docintelFormat == "video" ||
            userInputs?.docintelFormat == "Video"
          ) {
            navigate(
              "FOkB/AUT2wGXRv ablqvbg==" === "FOkB/AUT2wGXRv ablqvbg=="
                ? "/narrative/content-detail"
                : "/content-detail",
              {
                // state: { pdfId: res?.data?.data?.pdfId },
                state: {
                  pdfId: res?.data?.data?.pdfId,
                  flag: isLikeRdAccount
                    ? location?.state?.flag === "mandatory"
                      ? "mandatory"
                      : location?.state?.flag === "Non-mandatory"
                      ? "Non-mandatory"
                      : ""
                    : "",
                  title: isLikeRdAccount ? location?.state?.title : "",
                  draft: userInputs?.draft ? userInputs?.draft : "default_1",
                },
              }
            );
          } else {
            if (userInputs?.allowVideo) {
              navigate("/vwd/library-add-link", {
                state: {
                  pdfId: res?.data?.data?.pdfId,
                  isEdit: 0,
                  allowVideo: userInputs?.allowVideo,
                  flag: isLikeRdAccount
                    ? location?.state?.flag === "mandatory"
                      ? "mandatory"
                      : location?.state?.flag === "Non-mandatory"
                      ? "Non-mandatory"
                      : ""
                    : "",
                  title: isLikeRdAccount ? location?.state?.title : "",
                  draft: userInputs?.draft ? userInputs?.draft : "default_1",
                },
              });
            } else {
              navigate("/vwd/preview-content", {
                state: {
                  pdfId: res?.data?.data?.pdfId,
                  isEdit: 0,
                  title: location?.state?.title,
                  flag: isLikeRdAccount
                    ? location?.state?.flag === "Non-mandatory"
                      ? "Non-mandatory"
                      : "mandatory"
                    : "",
                  draft: userInputs?.draft ? userInputs?.draft : "default_1",
                },
              });
            }
          }
        } else {
          if (
            "FOkB/AUT2wGXRv ablqvbg==" == "rjiGlqA9DXJVH7bDDTX0Lg==" ||
            "FOkB/AUT2wGXRv ablqvbg==" == "bWmUjqX7J011   WUTYn9g=="
          ) {
            if (
              userInputs?.docintelFormat == "video" ||
              userInputs?.docintelFormat == "Video"
            ) {
              navigate("/set-popup", {
                state: {
                  pdfId: res?.data?.data?.pdfId,
                  fileType: userInputs?.docintelFormat,
                  isEdit: 0,
                  draft: userInputs?.draft ? userInputs?.draft : "default_1",
                },
              });
            } else {
              if (userInputs?.allowVideo) {
                navigate("/vwd/library-add-link", {
                  state: {
                    pdfId: res?.data?.data?.pdfId,
                    isEdit: 0,
                    allowVideo: userInputs?.allowVideo,
                    draft: userInputs?.draft ? userInputs?.draft : "default_1",
                  },
                });
              } else if (userInputs?.docintelFormat == "iframe") {
                console.log("here");
                navigate(
                  "FOkB/AUT2wGXRv ablqvbg==" === "FOkB/AUT2wGXRv ablqvbg=="
                    ? "/narrative/content-detail"
                    : "/content-detail",
                  {
                    state: {
                      pdfId: res?.data?.data?.pdfId,
                      fileType: userInputs?.docintelFormat,
                      isEdit: 0,
                      draft: userInputs?.draft
                        ? userInputs?.draft
                        : "default_1",
                    },
                  }
                );
              } else {
                navigate("/set-popup", {
                  state: {
                    pdfId: res?.data?.data?.pdfId,
                    fileType: userInputs?.docintelFormat,
                    isEdit: 0,
                    draft: userInputs?.draft ? userInputs?.draft : "default_1",
                  },
                });
              }
            }
          } else {
            if (
              "FOkB/AUT2wGXRv ablqvbg==" === "FOkB/AUT2wGXRv ablqvbg=="
            ) {
              if (
                userInputs?.docintelFormat === "iframe" ||
                userInputs?.docintelFormat === "Video" ||
                userInputs?.docintelFormat === "video"
              ) {
                navigate("/narrative/content-detail", {
                  state: {
                    pdfId: res?.data?.data?.pdfId,
                    fileType: userInputs?.docintelFormat,
                    isEdit: 0,
                    draft: userInputs?.draft || "default_1",
                  },
                });
              } else if (userInputs?.allowVideo) {
                navigate("/vwd/library-add-link", {
                  state: {
                    pdfId: res?.data?.data?.pdfId,
                    isEdit: 0,
                    allowVideo: userInputs?.allowVideo,
                    draft: userInputs?.draft ? userInputs?.draft : "default_1",
                  },
                });
              } else {
                navigate("/vwd/preview-content", {
                  state: {
                    pdfId: res?.data?.data?.pdfId,
                    fileType: userInputs?.docintelFormat,
                    ibu: userInputs?.ibu || "",
                    isEdit: 0,
                    draft: userInputs?.draft || "default_1",
                  },
                });
              }
            } else {
              if (
                userInputs?.docintelFormat == "video" ||
                userInputs?.docintelFormat == "Video"
              ) {
                navigate("/set-popup", {
                  state: {
                    pdfId: res?.data?.data?.pdfId,
                    fileType: userInputs?.docintelFormat,
                    ibu: userInputs?.ibu ? userInputs?.ibu : "",
                    isEdit: 0,
                    draft: userInputs?.draft ? userInputs?.draft : "default_1",
                  },
                });
              } else {
                if (userInputs?.allowVideo) {
                  navigate("/vwd/library-add-link", {
                    state: {
                      pdfId: res?.data?.data?.pdfId,
                      isEdit: 0,
                      allowVideo: userInputs?.allowVideo,
                      draft: userInputs?.draft
                        ? userInputs?.draft
                        : "default_1",
                    },
                  });
                }
                //  else if ("FOkB/AUT2wGXRv ablqvbg==" == "FOkB/AUT2wGXRv ablqvbg==") {
                //   navigate("/preview-content", {
                //     state: {
                //       pdfId: res?.data?.data?.pdfId,
                //       fileType: userInputs?.docintelFormat,
                //       ibu: userInputs?.ibu ? userInputs?.ibu : "",
                //       isEdit: 0,
                //       draft: userInputs?.draft ? userInputs?.draft : "default_1",
                //     },
                //   });
                // }

                // if ("FOkB/AUT2wGXRv ablqvbg==" === "FOkB/AUT2wGXRv ablqvbg==") {
                //   if (userInputs?.docintelFormat === "iframe") {
                //     navigate("/content-detail", {
                //       state: {
                //       pdfId: res?.data?.data?.pdfId,
                //       fileType: userInputs?.docintelFormat,
                //       isEdit: 0,
                //       draft: userInputs?.draft ? userInputs?.draft : "default_1",
                //     },
                //     });
                //   } else {
                //     navigate("/preview-content", {
                //       state: {
                //         pdfId: res?.data?.data?.pdfId,
                //         fileType: userInputs?.docintelFormat,
                //         ibu: userInputs?.ibu || "",
                //         isEdit: 0,
                //         draft: userInputs?.draft || "default_1",
                //       },
                //     });
                //   }
                // }
                else {
                  navigate("/set-popup", {
                    state: {
                      pdfId: res?.data?.data?.pdfId,
                      fileType: userInputs?.docintelFormat,
                      ibu: userInputs?.ibu ? userInputs?.ibu : "",
                      isEdit: 0,
                      draft: userInputs?.draft
                        ? userInputs?.draft
                        : "default_1",
                    },
                  });
                }
              }
            }
          }
        }
      } catch (err) {
        loader("hide");
      }
    }
  };

  const addMoreChClicked = () => {
    let isValid = true;
    let toastMessage = "";
    chapter.forEach((element) => {
      const isVideoExisting =
        element.type === "video" && element.videoType === "existing";
      const selectedVideoEmpty =
        !element.selectedVideo || element.selectedVideo === "";
      const uploadFileEmpty = !element.uploadFile || element.uploadFile === "";
      if (
        isVideoExisting &&
        selectedVideoEmpty &&
        userInputs.docintelFormat == "ebookVideo"
      ) {
        isValid = false;
        toastMessage = "Please select a video!";
      } else if (!isVideoExisting && uploadFileEmpty) {
        isValid = false;
        toastMessage = "Please input the chapter file atleast!";
      }
    });

    if (isValid) {
      setChapter([
        ...chapter,
        userInputs.docintelFormat == "ebookVideo"
          ? {
              // chapterFormat: "pdf",
              type: "pdf",
              chapterTitle: "",
              uploadFile: "",
              selectedVideo: "",
              ...("FOkB/AUT2wGXRv ablqvbg==" ===
                "FOkB/AUT2wGXRv ablqvbg==" && {
                chapterCategory:
                  userInputs?.category != "" ? userInputs?.category : "",
              }),
            }
          : {
              chapterTitle: "",
              uploadFile: "",
              selectedVideo: "",
            },
      ]);
    } else {
      toast.warning(toastMessage);
    }
  };

  const deleteRecord = (i) => {
    const list = chapter;
    list.splice(i, 1);
    ebookFile.splice(i, 1);
    setChapter(list);
    setEbookFile(ebookFile);
    setCounterFlag(counterFlag + 1);
  };

  const getLibraryDataOnSave = async () => {};

  const onChapterTitleChange = (e, i) => {
    const { value } = e.target;
    const list = [...chapter];
    // const list=JSON.parse(JSON.stringify(chapter))
    list[i].chapterTitle = value;
    setChapter(list);
  };

  const onChapterFormatChange = (e, i, isSelectedName) => {
    const list = [...chapter];
    list[i].type = e == true ? "video" : "pdf";
    list[i].uploadFile = "";
    list[i].selectedVideo = "";
    list[i].ebookFile = "";
    list[i].videoType = "";
    list[i].videoThumb = "";
    if (ebookFile[i]) {
      setEbookFile((prevEbookFile) => {
        const updatedEbookFile = [...prevEbookFile];
        updatedEbookFile.splice(i, 1);
        if (updatedEbookFile.length === 0) {
          return [];
        }
        return updatedEbookFile;
      });
    }
    if (e == true) {
      list[i].videoType = "existing";
      if (getVideoArticle.length == 0) {
        existingVideoArticle("existing");
      }
    }
    setChapter(list);
  };

  const existingVideoArticle = async (type) => {
    if (type == "existing" && getVideoArticle.length == 0) {
      const requestBody = {
        selectValue: JSON.stringify(["id", "title", "code"]),
        file_type: "'video'",
        is_file_name_exists: 1,
      };

      const response = await postData(ENDPOINT.LIBRARY, requestBody);
      // const response = await postData(ENDPOINT.LIBRARY_CONTENT, body);
      const hadData = response?.data?.data?.library || [];
      const pdfObj = hadData
        .map((item) => ({
          label: item.title.trim(),
          value: item.id,
        }))
        .sort((a, b) =>
          a.label.toLowerCase().localeCompare(b.label.toLowerCase())
        );
      setVideoArticle(pdfObj);
    }
  };

  const handleOnEbookChange = (e, i, url) => {
    const value = e.target.files[0]?.name;
    const list = [...chapter];
    list[i].uploadFile = value;
    list[i].selectedVideo = "";
    ebookFile[i] = e.target.files[0];
    setEbookFile(ebookFile);
    setChapter(list);
  };
  const handleOnEbookVideoChange = (url, i) => {
    const filename = url.split("/").pop();
    const value = filename;
    const list = [...chapter];
    list[i].uploadFile = value;
    list[i].selectedVideo = "";
    ebookFile[i] = filename;
    setEbookFile(ebookFile);
    setChapter(list);
  };

  const onPdfTitleChange = (e, i) => {
    const { value } = e.target;
    const list = [...pdfSpcData];
    list[i].chapterTitle = value;
    setpdfSpcData(list);
  };

  const handleOnEbookPdfChange = (e, i) => {
    const value = e.target.files[0]?.name;
    const list = [...pdfSpcData];
    list[i].uploadFile = value;
    ebookFile[i] = e.target.files[0];
    setEbookFile(ebookFile);
    setpdfSpcData(list);
  };

  const onChapterSelect = (event) => {
    setChapterSelect(event);
  };

  const onVideoSelect = (event) => {
    setVideoSelect(event);
  };

  const handleReseller = (e, data) => {
    let newData = [];
    if (e.target.checked) {
      newData = reseller;
      newData.push(data?.id);
    } else {
      newData = reseller?.filter((item) => item != data?.id);
    }
    setReseller(newData);
  };

  const onUploadNewVideoClicked = () => {
    setUploadNewVideo(true);
  };

  const onChangeEmbeddedVideo = (event) => {
    setChangeEmbeddedVideo(event);
  };
  const addNewProductClicked = (e) => {
    e.preventDefault();
    setCommanShow(true);
  };

  const topicButtonClicked = (group_id) => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setNewTag("");
    setIsOpen(false);
  };

  const tagClicked = (dd) => {
    if (!tagClickedFirst.includes(dd)) {
      setTagClickedFirst((oldArray) => [...oldArray, dd]);
    } else {
      {
        isLikeRdAccount
          ? toast.error("Topic already in list.")
          : toast.error("Topic already in list.");
      }
    }
  };
  const hcpClicked = (dd) => {
    if (!hcpClickedFirst.includes(dd)) {
      if (dd == "All") {
        setHcpClickedFirst(userDetail?.hcp);
      } else {
        setHcpClickedFirst((oldArray) => [...oldArray, dd]);
      }
    } else {
      toast.error("Role already Selected.");
    }
  };

  const hcpIrtClicked = (dd) => {
    if (!hcpIrtClickedFirst.includes(dd)) {
      if (dd == "All") {
        setHcpIrtClickedFirst(mandatoryRole);
      } else {
        const newArray = [dd];
        setHcpIrtClickedFirst(newArray);
        // setHcpIrtClickedFirst((oldArray) => [...oldArray, dd]);
      }
    } else {
      toast.error("Role already Selected.");
    }
  };

  const removeTagFinal = (index) => {
    const tagsClickedFirst = tagClickedFirst;
    tagsClickedFirst.splice(index, 1);
    setTagClickedFirst(tagsClickedFirst);

    setTagsReRender(tagsReRender + 1);
  };

  const removeHcp = (data, type = "") => {
    if (type == "irt") {
      const hcpData = hcpIrtClickedFirst.filter((item) => item != data);
      setHcpIrtClickedFirst(hcpData);
    } else {
      const hcpData = hcpClickedFirst.filter((item) => item != data);
      setHcpClickedFirst(hcpData);
    }
  };

  const newTagChanged = (e) => {
    setNewTag(e.target.value);
    e.target.value = "";
    const new_atg = document.getElementById("new-tag");
    new_atg.value = "";
  };

  const addTag = async () => {
    if (typeof newTag == "undefined" || newTag.trim().length == 0) {
      {
        isLikeRdAccount
          ? toast.error("Please input a topic")
          : toast.error("Please input a topic");
      }
    } else {
      loader("show");
      try {
        const hadData = await postData(ENDPOINT.ADD_TAGS, {
          product: newTag,
          type: 2,
          category: isLikeRdAccount ? 4 : 0,
          irt: location?.state?.flag == "mandatory" ? 1 : 0,
        });
        loader("hide");
        let temp_tags = tagClickedFirst.map((data) => {
          return data.toLowerCase();
        });
        let alltemp_tags = [];
        Object.entries(allTags).map((data) => {
          return alltemp_tags.push(...data);
        });
        alltemp_tags = alltemp_tags.map((data) => {
          return data.toLowerCase();
        });

        let prevtag = allTags;
        prevtag.push(newTag);
        setAllTags(prevtag);

        if (
          !temp_tags.includes(newTag.toLowerCase()) &&
          !alltemp_tags.includes(newTag.toLowerCase())
        ) {
          setTagClickedFirst((oldArray) => [...oldArray, newTag]);

          const body = {
            user_id: "FOkB/AUT2wGXRv ablqvbg==",
            tags: newTag,
          };
        } else {
          {
            isLikeRdAccount
              ? toast.error("Topic already in list.")
              : toast.error("Topic already in list.");
          }
        }
        setNewTag("");
        setTagsCounter(tagsCounter + 1);
      } catch (err) {
        console.log(err);
        loader("hide");
      }
    }
  };

  const saveButtonClicked = async () => {
    loader("show");

    if (typeof finalTags != "undefined" && finalTags.length > 0) {
      let prev_tags = finalTags;
      let new_tags = prev_tags.concat(tagClickedFirst);
      const uniqueTags = new_tags.filter((x, i, a) => a.indexOf(x) == i);
      setFinalTags(uniqueTags);
    } else {
      setFinalTags(tagClickedFirst);
    }
    setupdateFlag(updateflag + 1);
    closeModal();
    loader("hide");
  };

  const onSelectType = async (e, i, type) => {
    const list = [...chapter];
    list[i].type = type;
    setChapter(list);
  };

  const onSelectVideoType = async (e, i, type) => {
    const list = JSON.parse(JSON.stringify(chapter));
    list[i].videoType = type;
    list[i].videoThumb = "";
    list[i].uploadFile = "";
    list[i].selectedVideo = "";
    setChapter(list);
  };

  const handleVideoChange = (value, i) => {
    const list = [...chapter];
    // const list=JSON.parse(JSON.stringify(chapter))
    list[i].selectedVideo = value;
    list[i].videoThumb = "";
    list[i].uploadFile = "";
    setChapter(list);
  };

  const ebookChapterCategoryChange = (value, i) => {
    const list = [...chapter];
    list[i].chapterCategory = value;
    setChapter(list);
  };

  const handleOnVideoThumbChange = (e, i) => {
    const value = e.target.files[0]?.name;
    const list = [...chapter];
    // const list=JSON.parse(JSON.stringify(chapter))
    list[i].videoThumb = value;
    videoThumb[i] = e.target.files[0];
    setVideoThumb(videoThumb);
    setChapter(list);
  };

  const fetchAgeCategoriesData = async () => {
    try {
      loader("show");
      const res = await getData(ENDPOINT.CATEGORIES_AGE_GROUP);
      setAgeGroups(res?.data?.data?.ageGroups || []);
      setCategories(res?.data?.data?.categories || []);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      loader("hide");
    }
  };

  const publisherFun = () => {
    return (
      <div className="create-change-content">
        <div className="form_action">
          <h4>Who is involved</h4>
          <div className="row">
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">Company</label>
                <input
                  type="text"
                  className="form-control"
                  name="company"
                  onChange={handleChange}
                />
              </div>

              <div className="form-group margin-added">
                <label htmlFor="">Client product</label>
                <Select
                  options={userDetail?.product}
                  value={userInputs?.product}
                  onChange={(e) => handleChange(e, "product")}
                  placeholder="Select product"
                  className="dropdown-basic-button split-button-dropup edit-production-dropdown"
                  isClearable
                />
                <div className="add_product">
                  <span>&nbsp;</span>
                  <Button
                    onClick={addNewProductClicked}
                    className="btn-bordered btn-voilet"
                  >
                    Add New Product +
                  </Button>
                </div>
              </div>
              <div className="form-group">
                <label htmlFor="">Country</label>
                <Select
                  options={userDetail?.country || []}
                  placeholder="Select country"
                  onChange={(e) => handleChange(e?.value, "country")}
                  className="dropdown-basic-button split-button-dropup"
                  isClearable
                />
              </div>
              <div className="form-group">
                <label htmlFor="">Production</label>
                <Select
                  options={userDetail?.production}
                  onChange={(e) => handleChange(e?.id, "production")}
                  placeholder="Select own production person"
                  className="dropdown-basic-button split-button-dropup edit-production-dropdown"
                  isClearable
                />
              </div>

              {userDetail?.user?.[0]?.retailer == 1 ? (
                <div className="form-group">
                  <label htmlFor="">Pharma</label>
                  <Select
                    options={userDetail?.pharmaArr}
                    onChange={(e) => handleChange(e?.value, "pharmaArr")}
                    placeholder="Select pharma person"
                    className="dropdown-basic-button split-button-dropup edit-production-dropdown"
                    isClearable
                  />
                </div>
              ) : null}

              {"FOkB/AUT2wGXRv ablqvbg==" ==
                "rOhdD02MgXkownQqcreqAw==" && (
                <>
                  <div className="form-group">
                    <label htmlFor="">Sales</label>
                    <Select
                      options={userDetail?.sales}
                      placeholder="Who made the sale?"
                      onChange={(e) => handleChange(e?.id, "sales")}
                      className="dropdown-basic-button split-button-dropup edit-sales-dropdown"
                      isClearable
                    />
                  </div>
                </>
              )}
            </div>
            <div className="col-12 col-md-6 d-flex justify-content-end align-items-end right-change">
              <div className="form-group justify-content-end">
                <label htmlFor="">Reseller</label>
                <div className="form-check-group">
                  <div className="form-check-group-inset">
                    {userDetail?.reseller?.length ? (
                      userDetail?.reseller?.map((item, index) => {
                        return (
                          <div className="form-check" key={index}>
                            <input
                              className="form-check-input"
                              // value=""
                              id={"flexCheckDefault_" + index}
                              type="checkbox"
                              defaultValue={reseller.includes(item?.id) || ""}
                              onClick={(e) => handleReseller(e, item)}
                            />
                            <label
                              className="form-check-label"
                              htmlFor={"flexCheckDefault_" + index}
                            >
                              {item?.value}
                            </label>
                          </div>
                        );
                      })
                    ) : (
                      <>
                        <div className="form-check">
                          <label
                            className="form-check-label"
                            htmlFor="flexCheckReseller"
                          >
                            N/A
                          </label>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const docintelLink = () => {
    return (
      <div
        className={`${
          "FOkB/AUT2wGXRv ablqvbg==" === "FOkB/AUT2wGXRv ablqvbg=="
            ? "create-change-content wilprophy"
            : "create-change-content"
        }`}
      >
        <div className="form_action">
          <h4>About the Docintel link you're making</h4>
          <div className="row">
            <div
              className={`${
                ["UbCJcnLM9fe HsRMgX8c1A==",
                  "wW0geGtDPvig5gF 6KbJrg==",
                  "z2TunmZQf3QwCsICFTLGGQ==",
                  "qDgwPdToP05Kgzc g2VjIQ==",
                  "FOkB/AUT2wGXRv ablqvbg==",
                  "iSnEsKu5gB/DRlycxB6G4g=="].includes("FOkB/AUT2wGXRv ablqvbg==")
                  ? "col-12 col-md-12 form-action-full"
                  : "col-12 col-md-6"
              }`}
            >
              {userDetail?.user?.[0]?.flag != 1 &&
              userDetail?.user?.[0]?.group_id == 3 ? (
                <>
                  <div className="form-group val">
                    <label htmlFor="">
                      Category{" "}
                      {("FOkB/AUT2wGXRv ablqvbg==" === "FOkB/AUT2wGXRv ablqvbg==" || "FOkB/AUT2wGXRv ablqvbg==" === "iSnEsKu5gB/DRlycxB6G4g==") && <span>*</span>}{" "}
                    </label>
                    <Select
                      options={userDetail?.category}
                      placeholder="Select category type for HCPs to sort"
                      onChange={(e) => handleChange(e?.value, "category")}
                      // className="dropdown-basic-button split-button-dropup"
                      className={
                        "FOkB/AUT2wGXRv ablqvbg==" ===
                        "FOkB/AUT2wGXRv ablqvbg==" || "FOkB/AUT2wGXRv ablqvbg==" ===
                        "iSnEsKu5gB/DRlycxB6G4g=="
                          ? error?.category
                            ? "dropdown-basic-button split-button-dropup error"
                            : "dropdown-basic-button split-button-dropup"
                          : "dropdown-basic-button split-button-dropup"
                      }
                      isClearable
                    />
                    {("FOkB/AUT2wGXRv ablqvbg==" === "FOkB/AUT2wGXRv ablqvbg==" || "FOkB/AUT2wGXRv ablqvbg==" === "iSnEsKu5gB/DRlycxB6G4g==") &&
                      error?.category && (
                        <div className="login-validation">
                          {error?.category}
                        </div>
                      )}
                  </div>
                  {"FOkB/AUT2wGXRv ablqvbg==" !=
                  "FOkB/AUT2wGXRv ablqvbg==" && "FOkB/AUT2wGXRv ablqvbg==" != "iSnEsKu5gB/DRlycxB6G4g=="  && !octaLachChildAccounts.includes("FOkB/AUT2wGXRv ablqvbg==") ? (
                    <div className="form-group">
                      <label htmlFor="">Format</label>
                      <Select
                        options={userDetail?.format}
                        placeholder="Select format for tracking"
                        onChange={(e) => handleChange(e?.value, "format")}
                        className="dropdown-basic-button split-button-dropup"
                        isClearable
                      />
                    </div>
                  ) : null}
                </>
              ) : null}
              {userDetail?.user?.[0]?.flag == 0 &&
              userDetail?.user?.[0]?.group_id == 3 ? (
                <div className="form-group margin-added">
                  <label htmlFor="">
                    Product{" "}
                    {"FOkB/AUT2wGXRv ablqvbg==" ===
                      "FOkB/AUT2wGXRv ablqvbg==" && <span>*</span>}{" "}
                  </label>
                  <Select
                    options={userDetail?.product}
                    value={userInputs?.product}
                    placeholder="Select the product this is for"
                    onChange={(e) => handleChange(e, "product")}
                    // onChange={(e) => handleChange(e?.value, "product")}
                    // className="dropdown-basic-button split-button-dropup"
                    className={
                      "FOkB/AUT2wGXRv ablqvbg==" ===
                      "FOkB/AUT2wGXRv ablqvbg=="
                        ? error?.product
                          ? "dropdown-basic-button split-button-dropup error"
                          : "dropdown-basic-button split-button-dropup"
                        : "dropdown-basic-button split-button-dropup"
                    }
                    isClearable
                  />
                  {"FOkB/AUT2wGXRv ablqvbg==" ===
                    "FOkB/AUT2wGXRv ablqvbg==" &&
                    error?.product && (
                      <div className="login-validation">{error?.product}</div>
                    )}
                  <div className="add_product">
                    <span>&nbsp;</span>
                    <Button
                      onClick={addNewProductClicked}
                      className="btn-bordered btn-voilet"
                    >
                      Add New Product +
                    </Button>
                  </div>
                </div>
              ) : (
                <></>
              )}

              {"FOkB/AUT2wGXRv ablqvbg==" ===
              "FOkB/AUT2wGXRv ablqvbg==" ? (
                <>
                  <div className="form-group">
                    <label htmlFor="">
                      Associated Age <span>*</span>
                    </label>
                    <fieldset id="group3">
                      <div>
                      <label htmlFor="age-all">All</label>
                      <input
                        type="checkbox"
                        id="age-all"
                        value="All"
                        checked={userInputs?.associatedAge?.includes("All") || false}
                        onChange={(e) => handleAgeChange(e, "All", ageGroups)}
                      />
                      
                    </div>
                      {ageGroups.map((age) => {
                        const associatedAge =
                          age.min_age === null && age.max_age === null
                            ? null
                            : age.max_age === null
                            ? `Age >${age.min_age}`
                            : age.min_age === 0
                            ? `Age <${age.max_age}`
                            : `Age ${age.min_age}-${age.max_age}`;

                        if (!associatedAge) return null;
                        const specificAges = ["Age <6", "Age 6-11"];
                        const specificTouchpoints = [
                          "HMB",
                          "Pregnancy & Childbirth",
                        ];
                        const selectedTouchpoints =
                          userInputs?.associatedTouchpoint || [];

                        const anySpecificTP = selectedTouchpoints.some((tp) =>
                          specificTouchpoints.includes(tp)
                        );
                        const anyOtherTP = selectedTouchpoints.some(
                          (tp) => !specificTouchpoints.includes(tp)
                        );

                        const shouldDisable =
                          anySpecificTP &&
                          !anyOtherTP &&
                          specificAges.includes(associatedAge);

                        // NEW: remove disabled ages from state immediately
                        if (
                          shouldDisable &&
                          userInputs?.associatedAge?.includes(associatedAge)
                        ) {
                          userInputs.associatedAge =
                            userInputs.associatedAge.filter(
                              (a) => a !== associatedAge
                            );
                        }
                        

                        // const isChecked =
                        //   !shouldDisable &&
                        //   userInputs?.associatedAge?.includes(associatedAge);

                          // const isChecked =
                          // userInputs?.associatedAge?.includes("All") ||
                          // (!shouldDisable &&
                          //   userInputs?.associatedAge?.includes(associatedAge));

                            const isChecked =
                            userInputs?.associatedAge?.includes("All")
                              ? !shouldDisable // visually uncheck if disabled even when "All" is checked
                              : userInputs?.associatedAge?.includes(associatedAge);



                        return (
                          <div
                            key={age.id}
                            className={shouldDisable ? "disabled" : ""}
                          >
                            <label htmlFor={`age-${age.id}`}>
                              {associatedAge}
                            </label>
                            <input
                              type="checkbox"
                              value={associatedAge}
                              name="associatedAge"
                              id={`age-${age.id}`}
                              disabled={shouldDisable}
                              // checked={userInputs?.associatedAge?.includes(associatedAge) || false}
                              checked={isChecked || false}
                              onChange={(e) =>
                                handleAgeChange(e, associatedAge, ageGroups)
                              }
                            />
                          </div>
                        );
                      })}
                    </fieldset>
                    {error?.associatedAge && (
                      <div className="login-validation">
                        {error?.associatedAge}
                      </div>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="">
                      Associated Touchpoint <span>*</span>
                    </label>
                    <fieldset id="group4">
                    <div>
                    <label htmlFor="cat-all">All</label>
                    <input
                      type="checkbox"
                      id="cat-all"
                      value="All"
                      checked={userInputs?.associatedTouchpoint?.includes("All") || false}
                      onChange={(e) => handleTouchpointChange(e, "All", categories)}
                    />
                  </div>
                      {categories.map((cat, index) => {
                        if (index == 0) return;
                        // const shouldDisable =
                        //   (
                        //     cat.name === "Pregnancy & Childbirth" &&
                        //     (userInputs?.associatedAge?.includes("Age <6") ||
                        //     userInputs?.associatedAge?.includes("Age 6-11") )
                        //   ) ||
                        //   (
                        //     cat.name === "HMB" &&
                        //     (userInputs?.associatedAge?.includes("Age <6") ||
                        //     userInputs?.associatedAge?.includes("Age 6-11"))
                        //   );

                        const specificAges = ["Age <6", "Age 6-11"];
                        const specificTouchpoints = [
                          "HMB",
                          "Pregnancy & Childbirth",
                        ];
                        const selectedAges = userInputs?.associatedAge || [];

                        const anySpecificAge = selectedAges.some((age) =>
                          specificAges.includes(age)
                        );
                        const anyOtherAge = selectedAges.some(
                          (age) => !specificAges.includes(age)
                        );

                        const shouldDisable =
                          anySpecificAge &&
                          !anyOtherAge &&
                          specificTouchpoints.includes(cat.name);

                        // Remove disabled touchpoints from state immediately
                        if (
                          shouldDisable &&
                          userInputs?.associatedTouchpoint?.includes(cat.name)
                        ) {
                          userInputs.associatedTouchpoint =
                            userInputs.associatedTouchpoint.filter(
                              (tp) => tp !== cat.name
                            );
                        }

                        // const isChecked =
                        //   !shouldDisable &&
                        //   userInputs?.associatedTouchpoint?.includes(cat.name);

                        // const isChecked =
                        // userInputs?.associatedTouchpoint?.includes("All") ||
                        // (!shouldDisable &&
                        //   userInputs?.associatedTouchpoint?.includes(cat.name));

                        const isChecked = userInputs?.associatedTouchpoint?.includes("All")
                            ? !shouldDisable // visually uncheck if disabled even when "All" is checked
                            : userInputs?.associatedTouchpoint?.includes(cat.name);



                        return (
                          <div
                            key={cat.id}
                            className={shouldDisable ? "disabled" : ""}
                          >
                            <label htmlFor={`cat-${cat.id}`}>{cat?.name}</label>
                            <input
                              type="checkbox"
                              value={cat.name}
                              name="group4"
                              id={`cat-${cat.id}`}
                              disabled={shouldDisable}
                              // checked={
                              //   userInputs.associatedTouchpoint?.includes(cat.name) || false
                              // }
                              checked={isChecked || false}
                              onChange={(e) =>
                                handleTouchpointChange(e, cat.name, categories)
                              }
                            />
                          </div>
                        );
                      })}
                    </fieldset>
                    {error?.associatedTouchpoint && (
                      <div className="login-validation">
                        {error?.associatedTouchpoint}
                      </div>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="femaleOrien">
                      Female
                      <br />
                      oriented
                    </label>
                    <fieldset id="group5">
                      <div className="switch">
                        <label className="switch-light">
                          <input
                            type="checkbox"
                            value="value1"
                            name="group5"
                            id="femaleOrien"
                            onChange={(e) => {
                              handleChange(e.target?.checked, "femaleOriented");
                            }}
                          />
                          <span>
                            <span className="switch-btn active">No</span>
                            <span className="switch-btn ">Yes</span>
                          </span>
                          <a className="btn"></a>
                        </label>
                      </div>
                    </fieldset>
                  </div>

                  <div className="form-group">
                    <label htmlFor="hideinHCP">
                      Hide in HCP
                      <br />
                      mode
                    </label>
                    <fieldset id="group5">
                      <div className="switch">
                        <label className="switch-light">
                          <input
                            type="checkbox"
                            value="value1"
                            name="group5"
                            id="hideinHCP"
                            onChange={(e) => {
                              handleChange(e.target?.checked, "hideHCP");
                            }}
                          />
                          <span>
                            <span className="switch-btn active">No</span>
                            <span className="switch-btn ">Yes</span>
                          </span>
                          <a className="btn"></a>
                        </label>
                      </div>
                    </fieldset>
                  </div>

                  <div className="form-group ">
                    <label htmlFor="">
                      Topics <span>*</span>
                    </label>
                    <div className="input-group w-100" >
                      <div className="input-group-prepend">
                        <button
                          className="btn btn-filled btn-primary"
                          type="button"
                          id="tags-add"
                          data-bs-toggle="modal"
                          data-bs-target="#tagsModal"
                          onClick={(e) => {
                            const userId = "FOkB/AUT2wGXRv ablqvbg==";
                            if (userId === "FOkB/AUT2wGXRv ablqvbg==") {
                              setIsNewTopicModal(true);
                            } else {
                              topicButtonClicked(userDetail?.user[0]?.group_id);
                            }
                          }}
                        >
                          Add Topic +
                        </button>
                      </div>

                      <div className="tags_added">
                        <div className="select-tags"></div>
                        <ul>
                          {"FOkB/AUT2wGXRv ablqvbg==" ===
                          "FOkB/AUT2wGXRv ablqvbg=="
                            ? // Combine & sort clinical + functional topics
                              [
                                ...(selectedClinicalTopic?.map((tag) => ({
                                  type: "clinical",
                                  name: tag,
                                })) || []),
                                ...(selectedFunctionTopic?.map((tag) => ({
                                  type: "functional",
                                  name: tag,
                                })) || []),
                              ]
                                .sort((a, b) => a.name.localeCompare(b.name))
                                .map((tag, index) => (
                                  <li
                                    className={`list1 ${
                                      tag.type === "clinical"
                                        ? "clinical"
                                        : "functional"
                                    }`}
                                    title={
                                      tag.type === "clinical"
                                        ? "Clinical"
                                        : "Functional"
                                    }
                                    key={index}
                                  >
                                    {tag.name}
                                    <img
                                      src={
                                        tag.type === "clinical"
                                          ? path_image + "filter-close-blue.svg"
                                          : path_image + "filter-close.svg"
                                      }
                                      alt="Close-filter"
                                      style={{
                                        cursor: "pointer",
                                        marginLeft: "6px",
                                      }}
                                      onClick={() => {
                                        if (tag.type === "clinical") {
                                          setSelectedClinicalTopic((prev) =>
                                            prev.filter(
                                              (_, i) =>
                                                i !==
                                                selectedClinicalTopic.indexOf(
                                                  tag.name
                                                )
                                            )
                                          );
                                        } else {
                                          setSelectedFunctionTopic((prev) =>
                                            prev.filter(
                                              (_, i) =>
                                                i !==
                                                selectedFunctionTopic.indexOf(
                                                  tag.name
                                                )
                                            )
                                          );
                                        }
                                      }}
                                    />
                                  </li>
                                ))
                            : finalTags?.map((item, index) => (
                                <li className="list1" key={index}>
                                  {item}
                                  <img
                                    src={path_image + "filter-close.svg"}
                                    alt="Close-filter"
                                    onClick={() => removeTagFinal(index)}
                                  />
                                </li>
                              ))}

                          {/* Error display */}
                          {error?.tags && (
                            <div className="login-validation">{error.tags}</div>
                          )}
                        </ul>
                      </div>
                    </div>
                  </div>
                </>
              ) : null}

              {userDetail?.user?.[0]?.pharmaData == 1 &&
              userDetail?.user?.[0]?.group_id == 3 ? (
                <div className="form-group">
                  <label htmlFor="">Business Unit</label>
                  <Select
                    options={userDetail?.ibu}
                    placeholder="Select Business Unit"
                    onChange={(e) => handleChange(e?.value, "ibu")}
                    className="dropdown-basic-button split-button-dropup"
                    isClearable
                  />
                </div>
              ) : userDetail?.user?.[0]?.flag == 1 &&
                userDetail?.user?.[0]?.group_id == 3 ? (
                <></>
              ) : null}

              {userDetail?.user?.[0]?.flag == 0 &&
              userDetail?.user?.[0]?.pharmaData == 0 &&
              userDetail?.user?.[0]?.octaLach == 1 &&
              userDetail?.user?.[0]?.group_id == 3 ? (
                <div className="form-group">
                  <label htmlFor="">Content Use</label>
                  <fieldset id="group2">
                    <input
                      type="radio"
                      value="value2"
                      name="group2"
                      onClick={(e) => handleChange(1, "allowLibrary")}
                      id="limitagreed2"
                    />
                    <label htmlFor="limitagreed2">Library</label>

                    <input
                      type="radio"
                      value="value1"
                      name="group2"
                      onClick={(e) => handleChange(2, "allowLibrary")}
                      id="limitagreed1"
                    />
                    <label htmlFor="limitagreed1">Congress</label>
                  </fieldset>
                </div>
              ) : null}

              {["UbCJcnLM9fe HsRMgX8c1A==",
                "wW0geGtDPvig5gF 6KbJrg==",
                "z2TunmZQf3QwCsICFTLGGQ==",
                "qDgwPdToP05Kgzc g2VjIQ==",
                "iSnEsKu5gB/DRlycxB6G4g=="].includes("FOkB/AUT2wGXRv ablqvbg==") && (
                <div className="form-group ">
                  <label htmlFor="">
                    Topics
                  </label>
                  <div className="input-group w-100 m-0">
                    <div className="input-group-prepend">
                      <button
                        className="btn btn-filled btn-primary"
                        type="button"
                        id="tags-add"
                        data-bs-toggle="modal"
                        data-bs-target="#tagsModal"
                        onClick={(e) => {
                          setIsNewTopicModal(true);
                        }}
                      >
                        Add Topic +
                      </button>
                    </div>

                    <div className="tags_added">
                      <div className="select-tags"></div>
                      <ul>
                        {
                          // Combine & sort clinical + functional topics
                          [
                            ...(selectedClinicalTopic?.map((tag) => ({
                              type: "clinical",
                              name: tag,
                            })) || []),
                            ...(selectedFunctionTopic?.map((tag) => ({
                              type: "functional",
                              name: tag,
                            })) || []),
                          ]
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .map((tag, index) => (
                              <li
                                className={`list1 ${
                                  tag.type === "clinical"
                                    ? "clinical"
                                    : "functional"
                                }`}
                                title={
                                  tag.type === "clinical"
                                    ? "Clinical"
                                    : "Functional"
                                }
                                key={index}
                              >
                                {tag.name}
                                <img
                                  src={
                                    tag.type === "clinical"
                                      ? path_image + "filter-close-blue.svg"
                                      : path_image + "filter-close.svg"
                                  }
                                  alt="Close-filter"
                                  style={{
                                    cursor: "pointer",
                                    marginLeft: "6px",
                                  }}
                                  onClick={() => {
                                    if (tag.type === "clinical") {
                                      setSelectedClinicalTopic((prev) =>
                                        prev.filter(
                                          (_, i) =>
                                            i !==
                                            selectedClinicalTopic.indexOf(
                                              tag.name
                                            )
                                        )
                                      );
                                    } else {
                                      setSelectedFunctionTopic((prev) =>
                                        prev.filter(
                                          (_, i) =>
                                            i !==
                                            selectedFunctionTopic.indexOf(
                                              tag.name
                                            )
                                        )
                                      );
                                    }
                                  }}
                                />
                              </li>
                            ))
                        }
                        {/* Error display */}
                        {error?.tags && (
                          <div className="login-validation">{error.tags}</div>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
              )}

              {userDetail?.user?.[0]?.flag == 1 &&
              userDetail?.user?.[0]?.group_id == 3 ? (
                <>
                  <div className="form-group justify-content-start rd">
                    <label htmlFor="">Topics</label>
                    <div className="input-group w-100">
                      <div className="input-group-prepend">
                        <button
                          className="btn btn-filled btn-primary"
                          type="button"
                          id="tags-add"
                          data-bs-toggle="modal"
                          data-bs-target="#tagsModal"
                          onClick={(e) =>
                            topicButtonClicked(userDetail?.user[0]?.group_id)
                          }
                        >
                          Add Topic +
                        </button>
                      </div>
                      <div className="tags_added">
                        <div className="select-tags"></div>
                        <ul>
                          {finalTags?.map((item, index) => {
                            return (
                              <li className="list1" key={index}>
                                {item}
                                <img
                                  src={path_image + "filter-close.svg"}
                                  alt="Close-filter"
                                  onClick={() => removeTagFinal(index)}
                                />
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
            </div>

            {!isLikeRdAccount && ![
                "UbCJcnLM9fe HsRMgX8c1A==",
                "wW0geGtDPvig5gF 6KbJrg==",
                "z2TunmZQf3QwCsICFTLGGQ==",
                "qDgwPdToP05Kgzc g2VjIQ==",
                "FOkB/AUT2wGXRv ablqvbg==",
                "iSnEsKu5gB/DRlycxB6G4g=="
              ].includes("FOkB/AUT2wGXRv ablqvbg==")? (
              <>
                <div className="col-12 col-md-6 d-flex justify-content- align-items-start right-change flex-column">
                  <div className="form-group justify-content-end ">
                    <label htmlFor="">Topics</label>
                    <div className="input-group w-100">
                      <div className="input-group-prepend">
                        <button
                          className="btn btn-filled btn-primary"
                          type="button"
                          id="tags-add"
                          data-bs-toggle="modal"
                          data-bs-target="#tagsModal"
                          onClick={(e) =>
                            topicButtonClicked(userDetail?.user[0]?.group_id)
                          }
                        >
                          Add Topic +
                        </button>
                      </div>
                      <div className="tags_added">
                        <div className="select-tags"></div>
                        <ul>
                          {finalTags?.map((item, index) => {
                            return (
                              <li className="list1" key={index}>
                                {item}
                                <img
                                  src={path_image + "filter-close.svg"}
                                  alt="Close-filter"
                                  onClick={() => removeTagFinal(index)}
                                />
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : null}
          </div>
        </div>
      </div>
    );
  };

  const handleModelFun = (e) => {
    setUserDetail({ ...userDetail, newValue: e.target.value });
  };
  const handleSubmitModelFun = async (e) => {
    try {
      let body = {
        user_id: "FOkB/AUT2wGXRv ablqvbg==",
        product: userDetail?.newValue,
        category: 0,
        type: 1,
      };
      await postData(ENDPOINT.ADD_SPC_PRODUCT, body);
      let newAr = userDetail?.product;
      newAr.push({ value: userDetail?.newValu, label: userDetail?.newValue });

      setCreateLibraryInputs({
        ...userInputs,
        product: { value: userDetail?.newValue, label: userDetail?.newValue },
      });
      setUserDetail({ ...userDetail, product: newAr });
    } catch (err) {
      console.log("err", err);
    }
  };

  const LimitAgreed = () => {
    return (
      <div className="create-change-content">
        <div className="form_action">
          <h4>Limits agreed</h4>
          <div className="row">
            <div className="col-12 col-md-6">
              <div className="form-group">
                <label htmlFor="">Allow</label>
                <fieldset id="group2">
                  <input
                    type="checkbox"
                    value="value1"
                    name="group2"
                    onClick={(e) =>
                      handleChange(e.target?.checked, "allowPrint")
                    }
                    id="limitagreed1"
                  />
                  <label htmlFor="limitagreed1">Print</label>
                  <input
                    type="checkbox"
                    value="value2"
                    name="group2"
                    onClick={(e) =>
                      handleChange(e.target?.checked, "allowDownload")
                    }
                    id="limitagreed2"
                  />
                  <label htmlFor="limitagreed2">Download</label>
                </fieldset>
              </div>

              {userDetail?.user?.[0]?.retailer == 1 ? (
                <>
                  <div className="form-group">
                    <label htmlFor="">Status</label>
                    <fieldset id="group2">
                      <input
                        type="radio"
                        value="sold"
                        name="sold_unsold_status"
                        checked={
                          userInputs?.sold_unsold_status == "sold"
                            ? true
                            : false
                        }
                        onClick={(e) =>
                          handleChange("sold", "sold_unsold_status")
                        }
                        id="sold"
                      />
                      <label htmlFor="sold">Sold</label>
                      <input
                        type="radio"
                        value="unsold"
                        name="sold_unsold_status"
                        checked={
                          userInputs?.sold_unsold_status == "unsold"
                            ? true
                            : false
                        }
                        onClick={(e) =>
                          handleChange("unsold", "sold_unsold_status")
                        }
                        id="unsold"
                      />
                      <label htmlFor="unsold">Unsold</label>
                    </fieldset>
                    {error?.status ? (
                      <div className="login-validation">{error?.status}</div>
                    ) : null}
                  </div>

                  <div className="form-group">
                    <label htmlFor="setasdraft1">Request quote</label>
                    <fieldset id="request_quote">
                      <div className="switch">
                        <label className="switch-light">
                          <input
                            type="checkbox"
                            value="value1"
                            name="request_quote"
                            id="setasdraft1"
                            onChange={(e) => {
                              handleChange(e.target?.checked, "request_quote");
                            }}
                          />
                          <span>
                            <span className="switch-btn active">No</span>
                            <span className="switch-btn ">Yes</span>
                          </span>
                          <a className="btn"></a>
                        </label>
                      </div>
                    </fieldset>
                  </div>
                </>
              ) : null}
            </div>
            <div className="col-12 col-md-6 d-flex justify-content-end align-items-start right-change">
              <div className="form-group justify-content-end">
                <label htmlFor="">Invoice notes</label>
                <textarea
                  className="form-control"
                  id="formControlTextarea"
                  onChange={(e) =>
                    handleChange(e?.target.value, "specialRequirment")
                  }
                  rows="5"
                  placeholder="Please type your notes here..."
                ></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleAgeChange = (e, label, ageGroups) => {
    setCreateLibraryInputs((prev) => {
      const specificAges = ["Age <6", "Age 6-11"];
      const specificTouchpoints = ["HMB", "Pregnancy & Childbirth"];
      const selectedTouchpoints = prev.associatedTouchpoint || [];
      const selectedAgeGroups = prev.associatedAge || [];
      const availableAges = ageGroups
        .map((age) =>
          age.max_age === null && age.min_age === null
            ? null
            : age.max_age === null
            ? `Age >${age.min_age}`
            : age.min_age === 0
            ? `Age <${age.max_age}`
            : `Age ${age.min_age}-${age.max_age}`
        )
        .filter(Boolean);
      const availbleCategories = categories
        .map((item) => item.name)
        .filter((item) => item !== "Age-only");
      let updatedAges = [...selectedAgeGroups];
      let updatedTouchpoints = [...selectedTouchpoints];

      // age group setting
      if (label === "All") {
        if (e.target.checked) {
          if (
            (selectedTouchpoints.length == 2 &&
              selectedTouchpoints.includes("HMB") &&
              selectedTouchpoints.includes("Pregnancy & Childbirth")) ||
            (selectedTouchpoints.length == 1 &&
              (selectedTouchpoints.includes("HMB") ||
                selectedTouchpoints.includes("Pregnancy & Childbirth")))
          ) {
            updatedAges = [
              "All",
              ...availableAges.filter((item) => !specificAges.includes(item)),
            ];
          } else {
            updatedAges = ["All", ...availableAges];
          }
        } else {
          updatedAges = [];
        }
      } else {
        if (e.target.checked) {
          updatedAges = [...updatedAges, label];
          if(updatedAges.length === availableAges.length) updatedAges = ["All",...updatedAges]
        } else {
          updatedAges = updatedAges.filter((item) => item !== label && item !== "All");
        }
      }

      // touchpoints setting
      if (
        (updatedAges.length === 2 &&
          updatedAges.includes("Age <6") &&
          updatedAges.includes("Age 6-11")) ||
        (updatedAges.length === 1 &&
          (updatedAges.includes("Age <6") || updatedAges.includes("Age 6-11")))
      ) {
        updatedTouchpoints = updatedTouchpoints.filter(
          (item) => !specificTouchpoints.includes(item)
        );
      }
      else{
        if(updatedTouchpoints.includes("All")){
          updatedTouchpoints = ["All",...availbleCategories]
        }
      }
      return {
        ...prev,
        associatedAge: updatedAges,
        associatedTouchpoint: updatedTouchpoints,
      };
    })}

  // const handleAgeChange = (e, label, ageGroups) => {
  //   setCreateLibraryInputs((prev) => {
  //     const specificAges = ["Age <6", "Age 6-11"];
  //     const specificTouchpoints = ["HMB", "Pregnancy & Childbirth"];
  //     const selectedTouchpoints = prev.associatedTouchpoint || [];

  //     // Determine current disable condition (only specific touchpoints selected)
  //     const anySpecificTP = selectedTouchpoints.some((tp) =>
  //       specificTouchpoints.includes(tp)
  //     );
  //     const anyOtherTP = selectedTouchpoints.some(
  //       (tp) => !specificTouchpoints.includes(tp)
  //     );
  //     const shouldDisableSpecificAges = anySpecificTP && !anyOtherTP;

  //     let updatedAges = [...(prev.associatedAge || [])];

  //     // Handle "All" option
  //     if (label === "All") {
  //       if (e.target.checked) {
  //         // Select all valid age labels
  //         const allLabels = ageGroups
  //           .map((age) =>
  //             age.max_age === null && age.min_age === null
  //               ? null
  //               : age.max_age === null
  //               ? `Age >${age.min_age}`
  //               : age.min_age === 0
  //               ? `Age <${age.max_age}`
  //               : `Age ${age.min_age}-${age.max_age}`
  //           )
  //           .filter(Boolean);
  //         updatedAges = ["All", ...allLabels];
  //       } else {
  //         updatedAges = [];
  //       }
  //     } else {
  //       // Remove "All" if a specific age changed
  //       updatedAges = updatedAges.filter((a) => a !== "All");

  //       if (e.target.checked) {
  //         if (!(shouldDisableSpecificAges && specificAges.includes(label))) {
  //           updatedAges.push(label);
  //         }
  //       } else {
  //         updatedAges = updatedAges.filter((a) => a !== label);
  //       }

  //       // Check if all individual ages are selected → mark as "All"
  //       const totalAgeLabels = ageGroups
  //         .map((age) =>
  //           age.max_age === null && age.min_age === null
  //             ? null
  //             : age.max_age === null
  //             ? `Age >${age.min_age}`
  //             : age.min_age === 0
  //             ? `Age <${age.max_age}`
  //             : `Age ${age.min_age}-${age.max_age}`
  //         )
  //         .filter(Boolean);

  //       const allChecked =
  //         totalAgeLabels.length > 0 &&
  //         totalAgeLabels.every((l) => updatedAges.includes(l));

  //       if (allChecked) updatedAges = ["All", ...totalAgeLabels];
  //     }

  //     // 🚫 If only specific ages selected → disable HMB & Pregnancy & Childbirth
  //     const onlySpecificAgesSelected =
  //       specificAges.every((a) => updatedAges.includes(a)) &&
  //       updatedAges.filter((a) => specificAges.includes(a)).length === 2 &&
  //       updatedAges.length === 2;

  //     let updatedTouchpoints = [...selectedTouchpoints];
  //     if (onlySpecificAgesSelected) {
  //       updatedTouchpoints = updatedTouchpoints.filter(
  //         (tp) => !specificTouchpoints.includes(tp)
  //       );
  //     }

  //     return {
  //       ...prev,
  //       associatedAge: updatedAges,
  //       associatedTouchpoint: updatedTouchpoints,
  //     };
  //   });
  // };

  const handleTouchpointChange = (e, label, categories) => {
    setCreateLibraryInputs((prev) => {
      const specificAges = ["Age <6", "Age 6-11"];
      const specificTouchpoints = ["HMB", "Pregnancy & Childbirth"];
      const selectedTouchpoints = prev.associatedTouchpoint || [];
      const selectedAgeGroups = prev.associatedAge || [];
      const availableAges = ageGroups
        .map((age) =>
          age.max_age === null && age.min_age === null
            ? null
            : age.max_age === null
            ? `Age >${age.min_age}`
            : age.min_age === 0
            ? `Age <${age.max_age}`
            : `Age ${age.min_age}-${age.max_age}`
        )
        .filter(Boolean);
      const availbleCategories = categories
        .map((item) => item.name)
        .filter((item) => item !== "Age-only");
      let updatedAges = [...selectedAgeGroups];
      let updatedTouchpoints = [...selectedTouchpoints];
      // categories setting

      if (label === "All") {
        if (e.target.checked) {
          if (
            (updatedAges.length === 2 &&
              updatedAges.includes("Age <6") &&
              updatedAges.includes("Age 6-11")) ||
            (updatedAges.length === 1 &&
              (updatedAges.includes("Age <6") ||
                updatedAges.includes("Age 6-11")))
          ) {
            updatedTouchpoints = [
              "All",
              ...availbleCategories.filter((item) => !specificTouchpoints.includes(item)),
            ];
          } else {
            updatedTouchpoints = ["All", ...availbleCategories];
          }
        } else {
          updatedTouchpoints = [];
        }
      } else {
        if (e.target.checked) {
          updatedTouchpoints = [...updatedTouchpoints, label];
          if(updatedTouchpoints.length === availbleCategories.length) updatedTouchpoints = ["All",...updatedTouchpoints]
        } else {
          updatedTouchpoints = updatedTouchpoints.filter((item) => item !== label && item !== "All");
        }
      }

      //age group setting
      if (
        (updatedTouchpoints.length == 2 &&
          updatedTouchpoints.includes("HMB") &&
          updatedTouchpoints.includes("Pregnancy & Childbirth")) ||
        (updatedTouchpoints.length == 1 &&
          (updatedTouchpoints.includes("HMB") ||
          updatedTouchpoints.includes("Pregnancy & Childbirth")))
      ) {
        updatedAges = updatedAges.filter(
          (item) => !specificAges.includes(item)
        );
      } else {
        if (updatedAges.includes("All")) {
          updatedAges = ["All", ...availableAges];
        }

      }

      return {
        ...prev,
        associatedTouchpoint: updatedTouchpoints,
        associatedAge: updatedAges,
      };
    });
  };

  // const handleTouchpointChange = (e, label, categories) => {
  //   setCreateLibraryInputs((prev) => {
  //     const specificAges = ["Age <6", "Age 6-11"];
  //     const specificTouchpoints = ["HMB", "Pregnancy & Childbirth"];
  //     const selectedAges = prev.associatedAge || [];

  //     // Determine disable condition (only specific ages selected)
  //     const anySpecificAge = selectedAges.some((age) =>
  //       specificAges.includes(age)
  //     );
  //     const anyOtherAge = selectedAges.some(
  //       (age) => !specificAges.includes(age)
  //     );
  //     const shouldDisableSpecificTPs = anySpecificAge && !anyOtherAge;

  //     let updatedTP = [...(prev.associatedTouchpoint || [])];

  //     // Handle "All" option
  //     if (label === "All") {
  //       if (e.target.checked) {
  //         // Select all valid touchpoints
  //         const allTPs = categories
  //           .map((cat, i) => (i === 0 ? null : cat.name))
  //           .filter(Boolean);
  //         updatedTP = ["All", ...allTPs];
  //       } else {
  //         updatedTP = [];
  //       }
  //     } else {
  //       // Remove "All" if a specific TP changed
  //       updatedTP = updatedTP.filter((tp) => tp !== "All");

  //       if (e.target.checked) {
  //         if (!(shouldDisableSpecificTPs && specificTouchpoints.includes(label))) {
  //           updatedTP.push(label);
  //         }
  //       } else {
  //         updatedTP = updatedTP.filter((tp) => tp !== label);
  //       }

  //       // Check if all individual TPs are selected → mark as "All"
  //       const totalTPs = categories
  //         .map((cat, i) => (i === 0 ? null : cat.name))
  //         .filter(Boolean);

  //       const allChecked =
  //         totalTPs.length > 0 && totalTPs.every((tp) => updatedTP.includes(tp));

  //       if (allChecked) updatedTP = ["All", ...totalTPs];
  //     }

  //     // 🚫 If only specific touchpoints are selected → disable/uncheck Age <6 & Age 6-11
  //     const onlySpecificTPsSelected =
  //       specificTouchpoints.every((tp) => updatedTP.includes(tp)) &&
  //       updatedTP.filter((tp) => specificTouchpoints.includes(tp)).length === 2 &&
  //       updatedTP.length === 2;

  //     let updatedAges = [...selectedAges];
  //     if (onlySpecificTPsSelected) {
  //       updatedAges = updatedAges.filter((age) => !specificAges.includes(age));
  //     }

  //     return {
  //       ...prev,
  //       associatedTouchpoint: updatedTP,
  //       associatedAge: updatedAges,
  //     };
  //   });
  // };

  return (
    <>
      <Col className="right-sidebar custom-change">
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <div className="custom-container">
          <Row>
            <div className="page-top-nav sticky">
              <Row className="justify-content-end align-items-center">
                <Col md={1}>
                  <div className="header-btn-left"></div>
                </Col>
                <Col md={9}>
                  <ul className="tabnav-link">
                    <li className="active active-main">
                      <a href="">Create Your Content</a>
                    </li>
                    {("FOkB/AUT2wGXRv ablqvbg==" ==
                      "iSnEsKu5gB/DRlycxB6G4g==" ||
                      "FOkB/AUT2wGXRv ablqvbg==" ==
                        "B7SHpAc XDXSH NXkN0rdQ==" ||
                      "FOkB/AUT2wGXRv ablqvbg==" == isLikeRdAccount ||
                      "FOkB/AUT2wGXRv ablqvbg==" ==
                        "FOkB/AUT2wGXRv ablqvbg==") &&
                    userInputs?.allowVideo ? (
                      <li className="">
                        <a href="">[Embedding Video]</a>
                      </li>
                    ) : null}
                    {/* {!isLikeRdAccount ? (
                      <li className="">
                        <a href="">Edit Consent Option</a>
                      </li>
                    ) : null} */}

                    {!isLikeRdAccount &&
                    "FOkB/AUT2wGXRv ablqvbg==" !==
                      "FOkB/AUT2wGXRv ablqvbg==" ? (
                      <li className="">
                        <a href="">Edit Consent Option</a>
                      </li>
                    ) : null}

                    <li className="">
                      {/* <a href="">Approve Your Content &amp; Publish</a> */}
                      <a href="">
                        {" "}
                        {"FOkB/AUT2wGXRv ablqvbg==" ===
                        "FOkB/AUT2wGXRv ablqvbg=="
                          ? "Preview Your Content & Publish"
                          : "Approve Your Content & Publish"}
                      </a>
                    </li>
                  </ul>
                </Col>
                <Col md={2}>
                  <div className="header-btn">
                    <Link
                      className="btn btn-primary btn-bordered move-draft"
                      to="/vwd/library"
                      state={{
                        flag: isLikeRdAccount
                          ? location?.state?.flag === "mandatory"
                            ? "mandatory"
                            : location?.state?.flag === "Non-mandatory"
                            ? "Non-mandatory"
                            : ""
                          : "",
                        title: isLikeRdAccount ? location?.state?.title : "",
                      }}
                    >
                      Cancel
                    </Link>

                    <button
                      className="btn btn-primary btn-filled next "
                      onClick={nextButtonClicked}
                    >
                      Next
                    </button>
                  </div>
                </Col>
              </Row>
            </div>
            {userDetail?.user?.[0]?.group_id == 2
              ? publisherFun()
              : userDetail?.user?.[0]?.flag == 0 &&
                userDetail?.user?.[0]?.group_id == 3
              ? docintelLink()
              : userDetail?.user?.[0]?.flag == 1 &&
                userDetail?.user?.[0]?.group_id == 3
              ? docintelLink()
              : null}
            {userDetail?.user?.[0]?.group_id == 2 ? LimitAgreed() : null}

            <div
              className={`${
                "FOkB/AUT2wGXRv ablqvbg==" === "FOkB/AUT2wGXRv ablqvbg=="
                  ? "create-change-content wilprophy"
                  : "create-change-content"
              }`}
            >
              <div className="form_action">
                {userDetail?.user?.[0]?.group_id == 2 ? (
                  <h4>Creating the eprint</h4>
                ) : userDetail?.user?.[0]?.flag == 0 &&
                  userDetail?.user?.[0]?.group_id == 3 ? (
                  <h4>Creating the Docintel Link</h4>
                ) : userDetail?.user?.[0]?.flag == 1 &&
                  userDetail?.user?.[0]?.group_id == 3 ? (
                  <h4>Creating the Docintel Link</h4>
                ) : null}

                <Row>
                  <Col
                    className={`${
                      "FOkB/AUT2wGXRv ablqvbg==" ===
                      "FOkB/AUT2wGXRv ablqvbg==" || "FOkB/AUT2wGXRv ablqvbg==" ===
                      "iSnEsKu5gB/DRlycxB6G4g=="
                        ? "col-12 col-md-12 form-action-full"
                        : "col-12 col-md-6"
                    }`}
                  >
                    <div className="form-group val bigger">
                      <label htmlFor="">
                        Content title <span>*</span>
                      </label>
                      <input
                        type="text"
                        name="contentTitle"
                        className={
                          error?.contentTitle
                            ? "form-control error"
                            : "form-control"
                        }
                        ref={titleFieldRef}
                        onChange={(e) => {
                          handleChange(e);
                        }}
                      />
                      {error?.contentTitle ? (
                        <div className="login-validation">
                          {error?.contentTitle}
                        </div>
                      ) : null}
                    </div>

                    {userDetail?.user?.[0]?.flag == 1 &&
                    userDetail?.user?.[0]?.group_id == 3 ? (
                      <div className="form-group">
                        <label htmlFor="">Comment</label>

                        <textarea
                          className={
                            error?.journalTitle
                              ? "form-control error"
                              : "form-control"
                          }
                          id="formControlTextarea"
                          rows="5"
                          name="journalTitle"
                          onChange={(e) => handleChange(e)}
                          placeholder="Please type your comments here..."
                        ></textarea>

                        {error?.journalTitle ? (
                          <div className="login-validation">
                            {error?.journalTitle}
                          </div>
                        ) : null}
                      </div>
                    ) : (
                      <>
                        <div className="form-group bigger">
                          {userDetail?.user?.[0]?.flag == 0 &&
                          userDetail?.user?.[0]?.group_id == 3 ? (
                            <label htmlFor="">
                              Subtitle{" "}
                              {"FOkB/AUT2wGXRv ablqvbg==" ===
                                "FOkB/AUT2wGXRv ablqvbg==" && <span>*</span>}
                            </label>
                          ) : (
                            <label htmlFor="">Journal title</label>
                          )}

                          <input
                            type="text"
                            name="journalTitle"
                            className={
                              error?.journalTitle
                                ? "form-control error"
                                : "form-control"
                            }
                            onChange={(e) => handleChange(e)}
                          />
                          {error?.journalTitle ? (
                            <div className="login-validation">
                              {error?.journalTitle}
                            </div>
                          ) : null}
                        </div>

                        {"FOkB/AUT2wGXRv ablqvbg==" ===
                        "FOkB/AUT2wGXRv ablqvbg==" ? (
                          <>
                            <div className="form-group d-flex align-items-center event-date">
                              <label htmlFor="">
                                Creation date <span>*</span>
                              </label>
                              <DatePicker
                                name="creation_date"
                                autoComplete="off"
                                className={
                                  error?.creation_date
                                    ? "form-control error"
                                    : "form-control"
                                }
                                minDate={new Date()}
                                placeholderText="Select creation date"
                                selected={
                                  userInputs?.creation_date
                                    ? new Date(userInputs.creation_date)
                                    : null
                                }
                                onChange={(date) =>
                                  setCreateLibraryInputs((prev) => ({
                                    ...prev,
                                    creation_date: date,
                                  }))
                                }
                                dateFormat="dd/MM/yyyy"
                              />
                              {error?.creation_date && (
                                <div className="login-validation">
                                  {error?.creation_date}
                                </div>
                              )}
                            </div>
                          </>
                        ) : null}
                      </>
                    )}

                    {"FOkB/AUT2wGXRv ablqvbg==" ==
                    "B7SHpAc XDXSH NXkN0rdQ==" ? (
                      <>
                        <div className="form-group">
                          <label htmlFor="">Language</label>
                          <Select
                            options={language}
                            placeholder="Select language"
                            onChange={(e) => handleChange(e?.value, "language")}
                            className="dropdown-basic-button split-button-dropup"
                            isClearable
                          />
                        </div>

                        <div className="form-group val">
                          <label htmlFor="">Request New Language Code</label>
                          <input
                            type="text"
                            name="newLanguageCode"
                            placeholder="Enter Language name for the new language code"
                            className="form-control"
                            onChange={(e) => {
                              handleChange(e);
                            }}
                          />
                        </div>
                      </>
                    ) : null}

                    {"FOkB/AUT2wGXRv ablqvbg==" !=
                      "iSnEsKu5gB/DRlycxB6G4g==" &&
                    "FOkB/AUT2wGXRv ablqvbg==" !==
                      "FOkB/AUT2wGXRv ablqvbg==" &&
                    !isLikeRdAccount ? (
                      <div className="form-group">
                        <label htmlFor="">Author</label>
                        <input
                          type="text"
                          name="keyAuthor"
                          className="form-control"
                          onChange={handleChange}
                        />
                      </div>
                    ) : null}

                    {userDetail?.user?.[0]?.flag == 1 &&
                    userDetail?.user?.[0]?.group_id == 3 ? (
                      <>
                        {
                          <div className="form-group">
                            <label htmlFor="setasdraft5">Set as draft</label>
                            <fieldset id="group6">
                              <div className="switch">
                                <label className="switch-light">
                                  <input
                                    type="checkbox"
                                    value="value1"
                                    name="group6"
                                    id="setasdraft5"
                                    onChange={(e) => {
                                      handleChange(e.target?.checked, "draft");
                                    }}
                                  />
                                  <span>
                                    <span className="switch-btn active">
                                      No
                                    </span>
                                    <span className="switch-btn ">Yes</span>
                                  </span>
                                  <a className="btn"></a>
                                </label>
                              </div>
                            </fieldset>
                          </div>
                        }
                      </>
                    ) : null}
                    {userDetail?.user?.[0]?.flag == 0 &&
                    userDetail?.user?.[0]?.group_id == 3 ? (
                      <>
                        <div className="form-group">
                          {"FOkB/AUT2wGXRv ablqvbg==" ===
                          "FOkB/AUT2wGXRv ablqvbg==" ? (
                            <label htmlFor="">
                              Enable <span>*</span>
                            </label>
                          ) : (
                            <label htmlFor="">Allowed</label>
                          )}
                          <fieldset id="group2">
                            {"FOkB/AUT2wGXRv ablqvbg==" !==
                            "FOkB/AUT2wGXRv ablqvbg==" ? (
                              <>
                                <input
                                  type="checkbox"
                                  value="value1"
                                  name="group2"
                                  onClick={(e) =>
                                    handleChange(
                                      e.target?.checked,
                                      "allowPrint"
                                    )
                                  }
                                  id="limitagreedprint"
                                />
                                <label htmlFor="limitagreedprint">Print</label>

                                <input
                                  type="checkbox"
                                  value="value2"
                                  name="group2"
                                  checked={userInputs?.allowDownload}
                                  onClick={(e) =>
                                    handleChange(
                                      e.target?.checked,
                                      "allowDownload"
                                    )
                                  }
                                  id="limitagreeddown"
                                />
                                <label htmlFor="limitagreeddown">
                                  Download
                                </label>

                                <input
                                  type="checkbox"
                                  value="value3"
                                  onClick={(e) =>
                                    handleChange(
                                      e.target?.checked,
                                      "allowShare"
                                    )
                                  }
                                  name="group2"
                                  id="limitagreed3"
                                />
                                <label htmlFor="limitagreed3">Share</label>

                                <input
                                  type="checkbox"
                                  value="value4"
                                  name="group2"
                                  onClick={(e) =>
                                    handleChange(
                                      e.target?.checked,
                                      "allowRequest"
                                    )
                                  }
                                  id="limitagreed4"
                                />
                                <label htmlFor="limitagreed4">Request</label>
                              </>
                            ) : (
                              <>
                                <input
                                  type="checkbox"
                                  value="value2"
                                  name="group2"
                                  checked={userInputs?.allowDownload}
                                  onClick={(e) =>
                                    handleChange(
                                      e.target?.checked,
                                      "allowDownload"
                                    )
                                  }
                                  id="downloadcheck"
                                />
                                <label htmlFor="downloadcheck">Download</label>

                                <input
                                  type="checkbox"
                                  value="value3"
                                  name="group2"
                                  checked={userInputs?.allowShare}
                                  onClick={(e) =>
                                    handleChange(
                                      e.target?.checked,
                                      "allowShare"
                                    )
                                  }
                                  id="limitagreed3"
                                />
                                <label htmlFor="limitagreed3">Share</label>
                              </>
                            )}
                          </fieldset>
                          {error?.allowDownload ? (
                            <div className="login-validation">{error.allowDownload}</div>
                          ) : error?.allowShare ? (
                            <div className="login-validation">{error.allowShare}</div>
                          ) : null}
                        </div>
                        <div className="form-group">
                          <label htmlFor="setasdraft2">Set as draft</label>
                          <fieldset id="group6">
                            <div className="switch">
                              <label className="switch-light">
                                <input
                                  type="checkbox"
                                  value="value1"
                                  name="group6"
                                  id="setasdraft2"
                                  onChange={(e) => {
                                    handleChange(e.target?.checked, "draft");
                                  }}
                                />
                                <span>
                                  <span className="switch-btn active">No</span>
                                  <span className="switch-btn ">Yes</span>
                                </span>
                                <a className="btn"></a>
                              </label>
                            </div>
                          </fieldset>
                        </div>
                      </>
                    ) : null}


                    {"FOkB/AUT2wGXRv ablqvbg==" ==
                    "iSnEsKu5gB/DRlycxB6G4g==" ? (
                      <div className="form-group">
                        <label htmlFor="sync">
                          <img src={path_image + "vwd-logo2.svg"} />
                        </label>
                        <fieldset id="pushed_vwdJourney">
                          <div className="switch">
                            <label className="switch-light">
                              <input
                                type="checkbox"
                                value="value1"
                                name="pushed_vwdJourney"
                                id="pushed_vwdJourney"
                                onChange={(e) => {
                                  handleChange(
                                    e.target?.checked,
                                    "pushed_vwdJourney"
                                  );
                                }}
                              />
                              <span>
                                <span className="switch-btn active">No</span>
                                <span className="switch-btn">Yes</span>
                              </span>
                              <a className="btn"></a>
                            </label>
                          </div>
                        </fieldset>
                      </div>
                    ) : null}

                    {(userInputs?.pushed_vwdJourney == 1 || userInputs?.pushed_vwdJourney == true) && "FOkB/AUT2wGXRv ablqvbg==" ==  "iSnEsKu5gB/DRlycxB6G4g==" && (
                      <div className="vwd-toggle-box">
                        <div className="form-group">
                          <label htmlFor="">
                            Associated Age <span>*</span>
                          </label>
                          <fieldset id="group3" className="vwd-checkbox">
                            <div>
                            <input
                              type="checkbox"
                              id="age-all"
                              value="All"
                              checked={userInputs?.associatedAge?.includes("All") || false}
                              onChange={(e) => handleAgeChange(e, "All", ageGroups)}
                            />
                            <label htmlFor="age-all">All</label>
                          </div>
                            {ageGroups.map((age) => {
                              const associatedAge =
                                age.min_age === null && age.max_age === null
                                  ? null
                                  : age.max_age === null
                                  ? `Age >${age.min_age}`
                                  : age.min_age === 0
                                  ? `Age <${age.max_age}`
                                  : `Age ${age.min_age}-${age.max_age}`;

                              if (!associatedAge) return null;

                              // const shouldDisable =
                              // (
                              //   userInputs?.associatedTouchpoint?.includes("Pregnancy & Childbirth") &&
                              //   (associatedAge === "Age <6" || associatedAge === "Age 6-11")
                              // ) ||
                              // (
                              //   userInputs?.associatedTouchpoint?.includes("HMB") &&
                              //   (associatedAge === "Age <6" || associatedAge === "Age 6-11")
                              // );

                              const specificAges = ["Age <6", "Age 6-11"];
                              const specificTouchpoints = [
                                "HMB",
                                "Pregnancy & Childbirth",
                              ];
                              const selectedTouchpoints =
                                userInputs?.associatedTouchpoint || [];

                              const anySpecificTP = selectedTouchpoints.some(
                                (tp) => specificTouchpoints.includes(tp)
                              );
                              const anyOtherTP = selectedTouchpoints.some(
                                (tp) => !specificTouchpoints.includes(tp)
                              );

                              const shouldDisable =
                                anySpecificTP &&
                                !anyOtherTP &&
                                specificAges.includes(associatedAge);

                              // NEW: remove disabled ages from state immediately
                              if (
                                shouldDisable &&
                                userInputs?.associatedAge?.includes(
                                  associatedAge
                                )
                              ) {
                                userInputs.associatedAge =
                                  userInputs.associatedAge.filter(
                                    (a) => a !== associatedAge
                                  );
                              }

                              // const isChecked =
                              //   !shouldDisable &&
                              //   userInputs?.associatedAge?.includes(
                              //     associatedAge
                              //   );

                          //       const isChecked =
                          // userInputs?.associatedAge?.includes("All") ||
                          // (!shouldDisable &&
                          //   userInputs?.associatedAge?.includes(associatedAge));

                          const isChecked =
                            userInputs?.associatedAge?.includes("All")
                              ? !shouldDisable // visually uncheck if disabled even when "All" is checked
                              : userInputs?.associatedAge?.includes(associatedAge);

                              return (
                                <div
                                  key={age.id}
                                  className={shouldDisable ? "disabled" : ""}
                                >
                                  <input
                                    type="checkbox"
                                    value={associatedAge}
                                    name="associatedAge"
                                    id={`age-${age.id}`}
                                    disabled={shouldDisable}
                                    // checked={userInputs?.associatedAge?.includes(associatedAge) || false}
                                    checked={isChecked || false}
                                    onChange={(e) =>
                                      handleAgeChange(
                                        e,
                                        associatedAge,
                                        ageGroups
                                      )
                                    }
                                  />
                                  <label htmlFor={`age-${age.id}`}>
                                    {associatedAge}
                                  </label>
                                </div>
                              );
                            })}
                          </fieldset>
                          {error?.associatedAge && (
                            <div className="login-validation">
                              {error?.associatedAge}
                            </div>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="">
                            Associated Touchpoint <span>*</span>
                          </label>
                          <fieldset id="group4"  className="vwd-checkbox">
                             <div>
                              <input
                                type="checkbox"
                                id="cat-all"
                                value="All"
                                checked={userInputs?.associatedTouchpoint?.includes("All") || false}
                                onChange={(e) => handleTouchpointChange(e, "All", categories)}
                              />
                              <label htmlFor="cat-all">All</label>
                            </div>
                            {categories.map((cat, index) => {
                              if (index == 0) return;
                              // const shouldDisable =
                              //   (
                              //     cat.name === "Pregnancy & Childbirth" &&
                              //     (userInputs?.associatedAge?.includes("Age <6") ||
                              //     userInputs?.associatedAge?.includes("Age 6-11") )
                              //   ) ||
                              //   (
                              //     cat.name === "HMB" &&
                              //     (userInputs?.associatedAge?.includes("Age <6") ||
                              //     userInputs?.associatedAge?.includes("Age 6-11"))
                              //   );

                              const specificAges = ["Age <6", "Age 6-11"];
                              const specificTouchpoints = [
                                "HMB",
                                "Pregnancy & Childbirth",
                              ];
                              const selectedAges =
                                userInputs?.associatedAge || [];

                              const anySpecificAge = selectedAges.some((age) =>
                                specificAges.includes(age)
                              );
                              const anyOtherAge = selectedAges.some(
                                (age) => !specificAges.includes(age)
                              );

                              const shouldDisable =
                                anySpecificAge &&
                                !anyOtherAge &&
                                specificTouchpoints.includes(cat.name);

                              // Remove disabled touchpoints from state immediately
                              if (
                                shouldDisable &&
                                userInputs?.associatedTouchpoint?.includes(
                                  cat.name
                                )
                              ) {
                                userInputs.associatedTouchpoint =
                                  userInputs.associatedTouchpoint.filter(
                                    (tp) => tp !== cat.name
                                  );
                              }

                              // const isChecked =
                              //   !shouldDisable &&
                              //   userInputs?.associatedTouchpoint?.includes(
                              //     cat.name
                              //   );

                                //  const isChecked =
                                //   userInputs?.associatedTouchpoint?.includes("All") ||
                                //   (!shouldDisable &&
                                //     userInputs?.associatedTouchpoint?.includes(cat.name));

                                 const isChecked =
                                userInputs?.associatedTouchpoint?.includes("All")
                                  ? !shouldDisable // visually uncheck if disabled even when "All" is checked
                                  : userInputs?.associatedTouchpoint?.includes(cat.name);

                              return (
                                <div
                                  key={cat.id}
                                  className={shouldDisable ? "disabled" : ""}
                                >
                                  <input
                                    type="checkbox"
                                    value={cat.name}
                                    name="group4"
                                    id={`cat-${cat.id}`}
                                    disabled={shouldDisable}
                                    // checked={
                                    //   userInputs.associatedTouchpoint?.includes(cat.name) || false
                                    // }
                                    checked={isChecked || false}
                                    onChange={(e) =>
                                      handleTouchpointChange(
                                        e,
                                        cat.name,
                                        categories
                                      )
                                    }
                                  />
                                   <label htmlFor={`cat-${cat.id}`}>
                                    {cat?.name}
                                  </label>
                                </div>
                              );
                            })}
                          </fieldset>
                          {error?.associatedTouchpoint && (
                            <div className="login-validation">
                              {error?.associatedTouchpoint}
                            </div>
                          )}
                        </div>

                        <div className="form-group">
                          <label htmlFor="femaleOrien">
                            Female oriented
                          </label>
                          <fieldset id="group5">
                            <div className="switch">
                              <label className="switch-light">
                                <input
                                  type="checkbox"
                                  value="value1"
                                  name="group5"
                                  id="femaleOrien"
                                  onChange={(e) => {
                                    handleChange(
                                      e.target?.checked,
                                      "femaleOriented"
                                    );
                                  }}
                                />
                                <span>
                                  <span className="switch-btn active">No</span>
                                  <span className="switch-btn ">Yes</span>
                                </span>
                                <a className="btn"></a>
                              </label>
                            </div>
                          </fieldset>
                        </div>
                      </div>
                    )}

                    {"FOkB/AUT2wGXRv ablqvbg==" ==
                    "8ifsyLFPesoMf3AL6fS3sA==" ? (
                      <div className="form-group">
                        <label htmlFor="synconesource">
                          <img src={path_image + "menarini.png"} />
                        </label>
                        <fieldset id="pushed_article">
                          <div className="switch">
                            <label className="switch-light">
                              <input
                                type="checkbox"
                                value="value1"
                                name="pushed_article"
                                id="synconesource"
                                onChange={(e) => {
                                  handleChange(
                                    e.target?.checked,
                                    "pushed_article"
                                  );
                                }}
                              />
                              <span>
                                <span className="switch-btn active">No</span>
                                <span className="switch-btn">Yes</span>
                              </span>
                              <a className="btn"></a>
                            </label>
                          </div>
                        </fieldset>
                      </div>
                    ) : null}

                    {userDetail?.user?.[0]?.flag == 1 &&
                    userDetail?.user?.[0]?.group_id == 3 ? (
                      <>
                        {!isLikeRdAccount ? (
                          <div className="form-group">
                            <label htmlFor="setasdraft4">
                              {isLikeRdAccount
                                ? "Irt mandatory training"
                                : "Mandatory"}
                            </label>
                            <fieldset id="group2">
                              <div className="switch">
                                <label className="switch-light">
                                  <input
                                    type="checkbox"
                                    name="group2"
                                    id="setasdraft4"
                                    onChange={(e) => {
                                      handleChange(
                                        e.target?.checked,
                                        "mandatory"
                                      );
                                    }}
                                  />
                                  <span>
                                    <span
                                      className={`switch-btn ${
                                        userInputs?.mandatory == 0
                                          ? " Active"
                                          : ""
                                      }`}
                                    >
                                      No
                                    </span>
                                    <span
                                      className={`switch-btn ${
                                        userInputs?.mandatory == 1
                                          ? " Active"
                                          : ""
                                      }`}
                                    >
                                      Yes
                                    </span>
                                  </span>
                                  <a className="btn"></a>
                                </label>
                              </div>
                            </fieldset>
                          </div>
                        ) : (
                          ""
                        )}
                      </>
                    ) : null}

                    {location.state?.flag !== "mandatory" &&
                    userDetail?.user?.[0]?.flag == 1 &&
                    (!userInputs?.mandatory || userInputs?.mandatory == 0) &&
                    userDetail?.user?.[0]?.group_id == 3 ? (
                      <div className="form-group">
                        <label htmlFor="">Role</label>
                        <div className="input-group w-100">
                          <div className="tags_added">
                            <div className="select-tags">
                              <ul>
                                <>
                                  <li
                                    className={
                                      hcpClickedFirst.length == 5
                                        ? "list1 all fade-down"
                                        : "list1 all fade-up"
                                    }
                                    onClick={() => {
                                      hcpClicked("All");
                                    }}
                                  >
                                    All
                                  </li>
                                  {userDetail?.hcp?.map((item, index) => {
                                    return (
                                      <li
                                        key={index}
                                        className="list1"
                                        onClick={() => {
                                          hcpClicked(item);
                                        }}
                                      >
                                        {item}
                                      </li>
                                    );
                                  })}
                                </>
                              </ul>
                              <div className="after-selected">
                                <ul className="after-tag-selected">
                                  {hcpClickedFirst.map((item, index) => {
                                    return (
                                      <li className="list1" key={index}>
                                        {item}
                                        <img
                                          src={path_image + "filter-close.svg"}
                                          alt="Close-filter"
                                          onClick={() => removeHcp(item)}
                                        />
                                      </li>
                                    );
                                  })}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}

                    {location.state?.flag !== "mandatory" &&
                    userDetail?.user?.[0]?.flag == 1 &&
                    userInputs?.mandatory == 1 &&
                    userDetail?.user?.[0]?.group_id == 3 ? (
                      <div className="form-group">
                        <label htmlFor="">IRT role</label>
                        <div className="input-group w-100">
                          <div className="tags_added">
                            <div className="select-tags">
                              <ul className="after-tag-selected">
                                <>
                                  {mandatoryRole.map((item, index) => {
                                    return (
                                      <li
                                        key={index}
                                        className="list1"
                                        onClick={() => {
                                          hcpIrtClicked(item);
                                        }}
                                      >
                                        {item}
                                      </li>
                                    );
                                  })}
                                </>
                              </ul>
                              <div className="after-selected">
                                <ul className="after-tag-selected">
                                  {hcpIrtClickedFirst.map((item, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        {mandatoryRole?.includes(item) ? (
                                          <li className="list1">
                                            {item}
                                            <img
                                              src={path_image + "filter-close.svg"}
                                              alt="Close-filter"
                                              onClick={() =>
                                                removeHcp(item, "irt")
                                              }
                                            />
                                          </li>
                                        ) : null}
                                      </React.Fragment>
                                    );
                                  })}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}

                 {"FOkB/AUT2wGXRv ablqvbg==" === "90VIqoM675WT4/peSRnbSQ==" ? (
                  <div className="form-group margin-added">
                    <label>
                      Folder Name <span>*</span>
                    </label>

                    <Select
                      options={userDetail?.marketing_folder_name}
                      value={userInputs?.marketing_folder_name}
                      placeholder="Select the Folder name"
                      onChange={(e) => handleChange(e, "marketing_folder_name")}
                      className={
                        error?.marketing_folder_name
                          ? "dropdown-basic-button split-button-dropup error"
                          : "dropdown-basic-button split-button-dropup"
                      }
                      //  isClearable
                    />
                  </div>
                ) : null}

                    <div className="form-group val">
                      <label htmlFor="">
                        {"FOkB/AUT2wGXRv ablqvbg==" ===
                        "FOkB/AUT2wGXRv ablqvbg=="
                          ? "File format"
                          : "Docintel format"}{" "}
                        <span>*</span>
                      </label>
                      <Select
                        menuPlacement="top"
                        className={
                          error?.docintelFormat
                            ? "dropdown-basic-button split-button-dropup error"
                            : "dropdown-basic-button split-button-dropup"
                        }
                        options={ePrintType}
                        isClearable
                        placeholder="Select type of Docintel format "
                        onChange={(event) =>
                          handleChange(event?.value, "docintelFormat")
                        }
                      />
                      {error?.docintelFormat ? (
                        <div className="login-validation">
                          {error?.docintelFormat}
                        </div>
                      ) : null}
                    </div>

                    {userInputs.docintelFormat == "pdf" ? (
                      <div className="form-group val">
                        <label htmlFor="">Upload PDF</label>
                        <div className="upload-file-box">
                          <div className="box">
                            <input
                              type="file"
                              name="file-6[]"
                              id="file-6"
                              className={
                                error?.uploadFile
                                  ? "inputfile inputfile-6 error"
                                  : "inputfile inputfile-6"
                              }
                              accept="application/pdf"
                              onChange={(e) => handleChange(e, "uploadFile")}
                            />
                            <label htmlFor="file-6">
                              <span>
                                {userInputs?.uploadFile?.[0]?.name
                                  ? "Change Your File"
                                  : "Choose Your File"}
                              </span>
                            </label>
                            {userInputs?.uploadFile?.[0]?.name ? (
                              <p className="uploaded-file">
                                {userInputs?.uploadFile?.[0].name}
                              </p>
                            ) : (
                              <p>Upload your PDF</p>
                            )}
                          </div>
                        </div>
                        {error?.uploadFile ? (
                          <div className="login-validation-upload">
                            {error?.uploadFile}
                          </div>
                        ) : null}
                      </div>
                    ) : userInputs?.docintelFormat == "iframe" ? (
                      <div className="form-group val">
                        <label htmlFor="">Upload File</label>
                        <div className="upload-file-box">
                          <div className="box">
                            <input
                              type="file"
                              name="officeFile"
                              id="officeFile"
                              className={
                                error?.uploadOfficeFile
                                  ? "inputfile inputfile-6 error"
                                  : "inputfile inputfile-6"
                              }
                              accept=".doc,.docx,.xls,.xlsx,.ppt,.pptx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation"
                              onChange={(e) =>
                                handleChange(e, "uploadOfficeFile")
                              }
                            />
                            <label htmlFor="officeFile">
                              <span>
                                {userInputs?.uploadOfficeFile?.[0]?.name
                                  ? "Change Your File"
                                  : "Choose Your File"}
                              </span>
                            </label>
                            {userInputs?.uploadOfficeFile?.[0]?.name ? (
                              <p className="uploaded-file">
                                {userInputs?.uploadOfficeFile?.[0].name}
                              </p>
                            ) : (
                              <p>
                                Upload your File <br />
                                {"FOkB/AUT2wGXRv ablqvbg==" ===
                                  "FOkB/AUT2wGXRv ablqvbg==" && (
                                  <span className="file-size-text">
                                    ( Maximum size: 10 MB )
                                  </span>
                                )}
                              </p>
                            )}
                          </div>
                        </div>
                        {error?.uploadOfficeFile ? (
                          <div className="login-validation-upload">
                            {error?.uploadOfficeFile}
                          </div>
                        ) : null}
                      </div>
                    ) : userInputs?.docintelFormat == "video" ? (
                      <div className="form-group val">
                        <label htmlFor="">Upload video</label>
                        <div className="upload-file-box">
                          <div className="box">
                            {/* <input
                              type="file"
                              name="file-6[]"
                              id="file-6"
                              className="inputfile inputfile-6"
                              accept="video/mp4"
                              onChange={}
                            />
                            <label htmlFor="file-6">
                              <span>{userInputs?.uploadFile?.[0]?.name ? "Change Your File" : "Choose Your File"}</span>
                            </label> */}
                            <ResumableUploader
                              label={
                                userInputs?.uploadFile?.[0]?.name
                                  ? "Change Your File"
                                  : "Choose Your File"
                              }
                              handleFileSuccessCallback={async (url) =>
                                await handleChange(url, "videoUrl")
                              }
                              payload={{ method: "libraryType" }}
                              accept="mp4"
                            />
                            {userInputs?.uploadFile?.[0]?.name ? (
                              <p className="uploaded-file">
                                {userInputs?.uploadFile?.[0]?.name}
                              </p>
                            ) : userInputs?.videoFileName ? (
                              <p className="uploaded-file">
                                {userInputs?.videoFileName ?? ""}
                              </p>
                            ) : (
                              <p>Upload your Video file</p>
                            )}
                          </div>
                        </div>
                        {error?.uploadVideo ? (
                          <div className="login-validation-upload">
                            {error?.uploadVideo}
                          </div>
                        ) : null}
                      </div>
                    ) : userInputs.docintelFormat == "ebook" ||
                      userInputs.docintelFormat == "ebookVideo" ? (
                      chapter.map((val, i) => {
                        return (
                          <React.Fragment key={i}>
                            <div className="form-group val chapter-title">
                              <div className="ebook-format">
                                {userInputs.docintelFormat == "ebookVideo" ? (
                                  <>
                                    <div className="d-flex align-items-center justify-content-start w-100 mb-3">
                                      <label htmlFor="">
                                        {!isLikeRdAccount
                                          ? "Chapter "
                                          : "File "}
                                        {i + 1} format
                                      </label>
                                      <div className="switch">
                                        <label className="switch-light">
                                          <input
                                            type="checkbox"
                                            // checked={val?.chapterFormat == "video" ? true : false}
                                            checked={
                                              val?.type == "video"
                                                ? true
                                                : false
                                            }
                                            onChange={(e) => {
                                              onChapterFormatChange(
                                                e.target?.checked,
                                                i
                                              );
                                            }}
                                          />
                                          <span>
                                            <span className="switch-btn active">
                                              PDF
                                            </span>
                                            <span className="switch-btn">
                                              Video
                                            </span>
                                          </span>
                                          <a className="btn"></a>
                                        </label>
                                      </div>
                                      {
                                        // val?.chapterFormat == "video"?
                                        val?.type == "video" ? (
                                          <fieldset id="group7">
                                            :
                                            <div className="radio-selection">
                                              <input
                                                type="radio"
                                                name={`video-${i}`}
                                                id={`file-existing-${i}`}
                                                checked={
                                                  val?.videoType == "existing"
                                                    ? true
                                                    : false
                                                }
                                                // className="inputfile inputfile-6"
                                                // accept="video/mp4"
                                                onClick={(e) =>
                                                  onSelectVideoType(
                                                    e,
                                                    i,
                                                    "existing"
                                                  )
                                                }
                                              />
                                              <label
                                                htmlFor={`file-existing-${i}`}
                                              >
                                                <span>Existing video</span>
                                              </label>
                                              <input
                                                type="radio"
                                                name={`video-${i}`}
                                                id={`file-new-${i}`}
                                                checked={
                                                  val?.videoType == "new"
                                                    ? true
                                                    : false
                                                }
                                                // className="inputfile inputfile-6"
                                                // accept="video/mp4"
                                                onClick={(e) =>
                                                  onSelectVideoType(e, i, "new")
                                                }
                                              />
                                              <label htmlFor={`file-new-${i}`}>
                                                <span>Upload new</span>
                                              </label>
                                            </div>
                                          </fieldset>
                                        ) : null
                                      }
                                    </div>
                                    {"FOkB/AUT2wGXRv ablqvbg==" ===
                                      "FOkB/AUT2wGXRv ablqvbg==" && (
                                      <div className="form-group val">
                                        <label htmlFor="">
                                          Category <span>*</span>{" "}
                                        </label>
                                        <Select
                                          className="dropdown-basic-button split-button-dropup"
                                          value={
                                            userDetail?.category?.find(
                                              (option) =>
                                                option.value ===
                                                val.chapterCategory
                                            ) || null
                                          }
                                          onChange={(selectedOption) =>
                                            ebookChapterCategoryChange(
                                              selectedOption?.value || null,
                                              i
                                            )
                                          }
                                          options={userDetail?.category}
                                          isClearable
                                          placeholder="Select Category"
                                        />
                                      </div>
                                    )}
                                  </>
                                ) : null}
                                <label htmlFor="">
                                  {!isLikeRdAccount ? "Chapter " : "File "}
                                  {i + 1} title <span>*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  onChange={(e) => onChapterTitleChange(e, i)}
                                  value={val.chapterTitle}
                                />

                                {userInputs.docintelFormat == "ebookVideo" ? (
                                  <>
                                    <div className="upload-file-box">
                                      <div className="box">
                                        {val?.type == "video" ? (
                                          <>
                                            {val?.videoType == "new" ? (
                                              <>
                                                {/* <input
                                                  type="file"
                                                  name={`file-${i}`}
                                                  id={`file-${i}`}
                                                  className={
                                                    error?.chapter?.[i]
                                                      ? "inputfile inputfile-6 error"
                                                      : "inputfile inputfile-6"
                                                  }
                                                  accept="video/mp4"
                                                  onChange={(e) =>
                                                    handleOnEbookChange(e, i)
                                                  }
                                                />
                                                <label htmlFor={`file-${i}`}>
                                                  <span>
                                                    {val.uploadFile === ""
                                                      ? "Choose Your File"
                                                      : "Change Your File"}
                                                  </span>
                                                </label> */}
                                                <ResumableUploader
                                                  id={`file-${i}`}
                                                  name={`file-${i}`}
                                                  label={
                                                    val.uploadFile === ""
                                                      ? "Choose Your File"
                                                      : "Change Your File"
                                                  }
                                                  accept="mp4"
                                                  payload={{
                                                    method: "libraryType",
                                                  }}
                                                  handleFileSuccessCallback={async (
                                                    url
                                                  ) =>
                                                    handleOnEbookVideoChange(
                                                      url,
                                                      i
                                                    )
                                                  }
                                                />

                                                <p>
                                                  {val.uploadFile === "" ? (
                                                    <>
                                                      Upload your Video file
                                                      <span className="video-format">
                                                        (Only <b>mp4</b> format
                                                        is allowed)
                                                      </span>
                                                    </>
                                                  ) : (
                                                    <span className="uploaded-file">
                                                      {val.uploadFile}
                                                    </span>
                                                  )}
                                                </p>
                                              </>
                                            ) : val?.videoType == "existing" ? (
                                              <>
                                                <Select
                                                  className={
                                                    error?.docintelFormat
                                                      ? "dropdown-basic-button split-button-dropup error"
                                                      : "dropdown-basic-button split-button-dropup"
                                                  }
                                                  onChange={(event) =>
                                                    handleVideoChange(
                                                      event?.value,
                                                      i
                                                    )
                                                  }
                                                  options={getVideoArticle}
                                                  isClearable
                                                  placeholder="Select video"
                                                />
                                              </>
                                            ) : null}
                                          </>
                                        ) : // val?.chapterFormat == 'pdf' ?
                                        val?.type == "pdf" ? (
                                          <>
                                            <input
                                              type="file"
                                              name={`file-${i}`}
                                              id={`file-${i}`}
                                              className={
                                                error?.chapter?.[i]
                                                  ? "inputfile inputfile-6 error"
                                                  : "inputfile inputfile-6"
                                              }
                                              accept="application/pdf"
                                              onChange={(e) =>
                                                handleOnEbookChange(e, i)
                                              }
                                            />
                                            <label htmlFor={`file-${i}`}>
                                              <span>
                                                {val.uploadFile === ""
                                                  ? "Choose Your File"
                                                  : "Change Your File"}
                                              </span>
                                            </label>

                                            <p>
                                              {val.uploadFile == "" ? (
                                                "Upload your PDF file"
                                              ) : (
                                                <span className="uploaded-file">
                                                  {val.uploadFile}
                                                </span>
                                              )}
                                            </p>
                                          </>
                                        ) : null}
                                      </div>
                                    </div>

                                    {val?.videoType == "new" &&
                                    val.type == "video" ? (
                                      <div className="upload-file-box">
                                        <div className="box">
                                          <input
                                            type="file"
                                            name={`file-thumb-${i}`}
                                            id={`file-thumb-${i}`}
                                            className="inputfile inputfile-5"
                                            accept="image/png, image/jpeg"
                                            onChange={(e) =>
                                              handleOnVideoThumbChange(e, i)
                                            }
                                          />
                                          <label htmlFor={`file-thumb-${i}`}>
                                            <span>
                                              {val.videoThumb == ""
                                                ? "Choose Your Image"
                                                : "Change Your Image"}
                                            </span>
                                          </label>
                                          <p>
                                            {val.videoThumb == "" ? (
                                              "Upload chapter thumbnail"
                                            ) : (
                                              <span className="uploaded-file">
                                                {val.videoThumb}
                                              </span>
                                            )}
                                          </p>
                                        </div>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </>
                                ) : (
                                  <div className="upload-file-box">
                                    <div className="box">
                                      <input
                                        type="file"
                                        name={`file-${i}`}
                                        id={`file-${i}`}
                                        className={
                                          error?.chapter?.[i]
                                            ? "inputfile inputfile-6 error"
                                            : "inputfile inputfile-6"
                                        }
                                        accept="application/pdf"
                                        onChange={(e) =>
                                          handleOnEbookChange(e, i)
                                        }
                                      />
                                      <label htmlFor={`file-${i}`}>
                                        <span>
                                          {val?.uploadFile != ""
                                            ? "Change Your File"
                                            : "Choose Your File"}
                                        </span>
                                      </label>

                                      <p>
                                        {val.uploadFile == "" ? (
                                          "Upload your PDF file"
                                        ) : (
                                          <p className="uploaded-file">
                                            {val.uploadFile}
                                          </p>
                                        )}
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="chapter-btn-wrapper">
                                {chapter.length - 1 == i ? (
                                  <Button
                                    className="btn btn-primary btn-bordered btn-voilet move-draft chappter-add-btn"
                                    onClick={addMoreChClicked}
                                  >
                                    Add Ch +
                                  </Button>
                                ) : null}

                                {chapter.length > 1 ? (
                                  <Button
                                    className="dlt_btn"
                                    onClick={() => deleteRecord(i, val?.id)}
                                  >
                                    <img
                                      src={path_image + "delete.svg"}
                                      alt="Delete Row"
                                    />
                                  </Button>
                                ) : null}
                              </div>
                              {error?.chapter?.[i] ? (
                                <div className="login-validation-upload">
                                  {error?.chapter?.[i]}
                                </div>
                              ) : null}
                            </div>
                            <br />
                          </React.Fragment>
                        );
                      })
                    ) : userInputs.docintelFormat == "pdfSpc" ? (
                      pdfSpcData.map((val, i) => {
                        return (
                          <React.Fragment key={i}>
                            <div className="form-group val chapter-title pdf-spc">
                              <div className="ebook-format">
                                <label htmlFor="">
                                  {!isLikeRdAccount ? "Chapter " : "File "}{" "}
                                  title
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  onChange={(e) => onPdfTitleChange(e, i)}
                                  value={val.chapterTitle}
                                />
                                <div className="upload-file-box">
                                  <div className="box">
                                    <input
                                      type="file"
                                      name={`file-${i}`}
                                      id={`file-${i}`}
                                      className={
                                        error?.chapter?.[i]
                                          ? "inputfile inputfile-6 error"
                                          : "inputfile inputfile-6"
                                      }
                                      accept="application/pdf"
                                      onChange={(e) =>
                                        handleOnEbookPdfChange(e, i)
                                      }
                                    />
                                    <label htmlFor={`file-${i}`}>
                                      <span>
                                        {val.uploadFile != ""
                                          ? "Change Your File"
                                          : "Choose Your File"}
                                      </span>
                                    </label>

                                    <p>
                                      {val.uploadFile == "" ? (
                                        "Upload your PDF file"
                                      ) : (
                                        <p className="uploaded-file">
                                          {val.uploadFile}
                                        </p>
                                      )}
                                    </p>
                                  </div>
                                </div>
                              </div>
                              {error?.pdfChapter?.[i] ? (
                                <div className="login-validation-upload">
                                  {error?.pdfChapter?.[i]}
                                </div>
                              ) : null}
                            </div>
                          </React.Fragment>
                        );
                      })
                    ) : null}

                    {userDetail?.user?.[0]?.flag == 0 &&
                    userDetail?.user?.[0]?.group_id == 3 ? (
                      <></>
                    ) : null}
                    {(ebookFile?.length &&
                      userInputs.docintelFormat == "ebook") ||
                    ["ebook", "pdf", "pdfSpc"].includes(
                      userInputs.docintelFormat
                    ) ||
                    (ebookFile?.length &&
                      userInputs.docintelFormat == "ebookVideo" &&
                      chapter.some((element) => element?.type == "pdf")) ? (
                      <>
                        <div className="form-group">
                          <label htmlFor="">Embed video</label>
                          <div className="switch">
                            <label className="switch-light">
                              <input
                                type="checkbox"
                                checked={userInputs?.allowVideo ? true : false}
                                onChange={(e) => {
                                  handleChange(e.target?.checked, "allowVideo");
                                }}
                              />
                              <span>
                                <span className="switch-btn active">No</span>
                                <span className="switch-btn">Yes</span>
                              </span>
                              <a className="btn"></a>
                            </label>
                          </div>
                        </div>
                      </>
                    ) : null}
                    {"FOkB/AUT2wGXRv ablqvbg==" !==
                    "FOkB/AUT2wGXRv ablqvbg==" ? (
                      <div className="form-group val">
                        <label htmlFor="">Content cover</label>
                        <div className="upload-file-box">
                          <div className="box">
                            <input
                              type="file"
                              name="file-cover[]"
                              id="file-cover"
                              className="inputfile inputfile-5"
                              accept="image/png, image/jpeg"
                              onChange={(e) => handleChange(e, "coverPhoto")}
                            />
                            <label htmlFor="file-cover">
                              <span>
                                {userInputs?.coverPhoto?.[0]?.name
                                  ? "Change Your File"
                                  : "Choose Your File"}
                              </span>
                            </label>
                            {userInputs?.coverPhoto?.[0]?.name ? (
                              <p className="uploaded-file">
                                {userInputs?.coverPhoto?.[0]?.name}
                              </p>
                            ) : (
                              <p>
                                Upload an alternative cover <br />
                                <span>
                                  <i>Allowed formats: PNG,JPEG</i>
                                </span>
                                <br />
                                <span>(Recommended size 88 X 124)</span>
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </Col>

                  {!isLikeRdAccount &&
                  "FOkB/AUT2wGXRv ablqvbg==" !==
                    "FOkB/AUT2wGXRv ablqvbg==" ? (
                    <Col
                      md={12}
                      className="d-flex justify-content-end align-items-start right-change" 
                    >
                      <div className="form-group justify-content-start">
                        <label htmlFor="">
                          Production notes to Docintel team
                        </label>
                        <textarea
                          className="form-control textarea"
                          id="formControlTextarea"
                          rows="2"
                          onChange={(e) =>
                            handleChange(e?.target.value, "productionNotes")
                          }
                          placeholder="Please type your notes here..."
                        ></textarea>
                      </div>
                    </Col>
                  ) : null}
                </Row>
              </div>
            </div>
          </Row>
        </div>
      </Col>
      <Modal className="pdf-video-link" show={show} onHide={handleClose}>
        <Modal.Header>
          <div className="form_action embedding-video">
            <div className="side-step-text first-step">
              <div className="embedded-video-step">
                <h2>Step1</h2>
              </div>
              <p>Select the chapter </p>
              <Form.Group className="formgroup">
                <Form.Label>Chapters</Form.Label>

                <DropdownButton
                  className="dropdown-basic-button split-button-dropup "
                  title={
                    chapterSelect != "" ? chapterSelect : "Select your chapter"
                  }
                  onSelect={(event) => onChapterSelect(event)}
                >
                  <div className="scroll_div">
                    <Dropdown.Item
                      eventKey="Chapter 1"
                      className={chapterSelect == "Chapter 1" ? "active" : ""}
                    >
                      Chapter 1
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="Chapter 2"
                      className={chapterSelect == "Chapter 2" ? "active" : ""}
                    >
                      Chapter 2
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="Chapter 3"
                      className={chapterSelect == "Chapter 3" ? "active" : ""}
                    >
                      Chapter 3
                    </Dropdown.Item>
                  </div>
                </DropdownButton>
              </Form.Group>
            </div>
            <div className="side-step-text second-step">
              <div className="embedded-video-step">
                <h2>Step2</h2>
              </div>
              <p>
                Select the video and highlight the area you want to embed the
                video in{" "}
              </p>
              <Form.Group className="formgroup">
                <Form.Label>
                  Videos <span>*</span>
                </Form.Label>
                <DropdownButton
                  className="dropdown-basic-button split-button-dropup "
                  title={videoSelect != "" ? videoSelect : "Select your video"}
                  onSelect={(event) => onVideoSelect(event)}
                >
                  <div className="scroll_div">
                    <Dropdown.Item
                      eventKey="Video 1"
                      className={videoSelect == "Video 1" ? "active" : ""}
                    >
                      Video 1
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="Video 2"
                      className={videoSelect == "Video 2" ? "active" : ""}
                    >
                      Video 2
                    </Dropdown.Item>
                    <Dropdown.Item
                      eventKey="Video 3"
                      className={videoSelect == "Video 3" ? "active" : ""}
                    >
                      Video 3
                    </Dropdown.Item>
                  </div>
                </DropdownButton>

                <div className="upload-file-box">
                  <Button
                    className="btn-filled"
                    onClick={onUploadNewVideoClicked}
                  >
                    Upload new Video +
                  </Button>
                </div>
              </Form.Group>
            </div>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="modal-body-content">
            <img src={path_image + "pdf-dummy.png"} alt="Close-filter" />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="btn-bordered"
            variant="secondary"
            onClick={handleClose}
          >
            Close
          </Button>
          <Button
            className="btn-filled"
            variant="primary"
            onClick={() => navigate("/edit-Consent-Options")}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={uploadNewVideo} className="send-confirm" id="download-qr">
        <Modal.Header>
          <h5 className="modal-title" id="staticBackdropLabel">
            Change Embedded Video
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            onClick={() => {
              setUploadNewVideo(false);
            }}
          ></button>
        </Modal.Header>
        <Modal.Body>
          <div className="form-group">
            <label htmlFor="">Video</label>
            <DropdownButton
              className="dropdown-basic-button split-button-dropup "
              title={
                changeEmbeddedVideo != ""
                  ? changeEmbeddedVideo
                  : "Select your video"
              }
              onSelect={(event) => onChangeEmbeddedVideo(event)}
            >
              <div className="scroll_div">
                <Dropdown.Item
                  eventKey="Change Video 1"
                  className={
                    changeEmbeddedVideo == "Change Video 1" ? "active" : ""
                  }
                >
                  Change Video 1
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="Change Video 2"
                  className={
                    changeEmbeddedVideo == "Change Video 2" ? "active" : ""
                  }
                >
                  Change Video 2
                </Dropdown.Item>
                <Dropdown.Item
                  eventKey="Change Video 3"
                  className={
                    changeEmbeddedVideo == "Change Video 3" ? "active" : ""
                  }
                >
                  Change Video 3
                </Dropdown.Item>
              </div>
            </DropdownButton>
          </div>
        </Modal.Body>

        <div className="modal-footer">
          <button
            type="button"
            disabled={changeEmbeddedVideo == "" ? true : false}
            className="btn btn-primary save btn-filled"
            onClick={() => setUploadNewVideo(false)}
          >
            Apply
          </button>
        </div>
      </Modal>

      <AddTopicsModal
        shown={isNewTopicModal}
        clinicalTopic={clinicalTopic}
        functionTopic={functionTopic}
        setclinicalTopic={setClinicalTopic}
        setfunctionTopic={setFunctionTopic}
        selectedClinicalTopic={selectedClinicalTopic}
        selectedFunctionTopic={selectedFunctionTopic}
        setselectedClinicalTopic={setSelectedClinicalTopic}
        setselectedFunctionTopic={setSelectedFunctionTopic}
        getLibraryDataOnSave={getLibraryDataOnSave}
        onClose={() => setIsNewTopicModal(false)}
      />

      <CommonModel
        show={commanShow}
        onClose={setCommanShow}
        heading={"Add New Product"}
        data={product}
        footerButton={"Add"}
        handleChange={handleModelFun}
        handleSubmit={handleSubmitModelFun}
      />

      <Modal id="tagsModal" show={isOpen}>
        <Modal.Header>
          <h5 className="modal-title" id="staticBackdropLabel">
            Add Topic
          </h5>
          <button
            type="button"
            className="btn-close"
            onClick={closeModal}
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </Modal.Header>
        <Modal.Body>
          <div className="select-tags">
            <h6>Select Topic :</h6>
            <div className="tag-lists">
              <div className="tag-lists-view">
                {Object.values(allTags).map((data, index) => {
                  return (
                    <div key={index} onClick={(event) => tagClicked(data)}>
                      {data}{" "}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
          <div className="selected-tags">
            <h6>
              Selected Topic <span>| {tagClickedFirst.length}</span>
            </h6>

            <div className="total-selected">
              {tagClickedFirst.map((data, index) => {
                return (
                  <>
                    <div className="tag-cross">
                      {data.innerHTML || data}
                      <img
                        src={path_image + "filter-close.svg"}
                        alt="Close-filter"
                        onClick={() => removeTagFinal(index)}
                      />
                    </div>
                  </>
                );
              })}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <form>
            <div className="form-group">
              <label htmlFor="new-tag">
                {" "}
                {"FOkB/AUT2wGXRv ablqvbg==" ===
                  "B7SHpAc XDXSH NXkN0rdQ==" || isLikeRdAccount
                  ? "New Topic"
                  : "New Topic"}{" "}
              </label>
              <input
                type="text"
                className="form-control"
                id="new-tag"
                value={newTag}
                onChange={(e) => newTagChanged(e)}
              />

              <button
                onClick={addTag}
                type="button"
                className="btn btn-primary add btn-bordered"
              >
                Add
              </button>
            </div>
          </form>
          <button
            type="button"
            className="btn btn-primary save btn-filled"
            onClick={saveButtonClicked}
          >
            Save
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default LibraryCreateVWD;
